// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-23T20:39:48.528Z
// Property: Holly Court (ID: 6767906449166928)
// Collections: 24 amenities, 25 floorplans (live), 17 photos, 75 POIs, 3 reviews, 1 virtual tours, 6 office hours, 2 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162442",
  "multihub_property_id": "6767906449166928",
  "property_external_id": "30929",
  "property_zillow_url": "https://www.zillow.com/apartments/pitman-nj/holly-court/5XkHMP/",
  "property_apartments_url": "https://www.apartments.com/holly-court-pitman-nj/5779tpq/",
  "property_google_business_url": "https://www.google.com/maps/place/Holly+Court+Apartment+Homes/data=!4m2!3m1!1s0x0:0x2bbbed7892f626da?sa=X&ved=2ahUKEwjl0bLakrmSAxXnliYFHWzDCYAQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "40540853429",
  "property_crm_software": "EliseAI",
  "property_pm_software": null,
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "holly-court",
  "property_name": "Holly Court",
  "property_website_url": "https://www.livehollycourt.com/",
  "property_domain": "https://www.livehollycourt.com/",
  "property_address": "601 West Holly Avenue",
  "property_full_address": "601 W Holly Ave, Pitman, NJ 08071",
  "property_address_1": "601 W Holly Ave",
  "property_address_2": null,
  "property_address_city": "Pitman",
  "property_address_state": "NJ",
  "property_address_zip_full": "08071-1300",
  "property_address_zip": "08071",
  "property_address_country": "US",
  "property_address_county": "Gloucester County",
  "property_neighborhood_address": "Lower Gloucester County",
  "property_address_latitude": "39.7318209",
  "property_address_longitude": "-75.1446874",
  "property_email": "hollycourt@aionmanagement.com",
  "property_phone": "(856) 589-1801",
  "property_call_tracking_phone": "877-447-9124",
  "property_company_name": "AION Management ",
  "property_company_url": "https://www.aionmanagement.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Holly Court, Pitman, NJ’s ideal apartment community. Choose from stylish studio, one- or two-bedroom floor plans, complete with modern amenities like a refreshing pool and fitness center. Unwind on our sundeck, enjoy our dog park, or relax by the serene pond. Your perfect home awaits!",
  "property_long_description": "**Welcome to Holly Court: Your Ideal Apartment Community in Pitman, NJ**\n\nDiscover the perfect blend of comfort and convenience at Holly Court, where our diverse selection of floor plans includes cozy studios, spacious one-bedroom, and inviting two-bedroom apartments designed to suit your lifestyle. With modern amenities and thoughtfully designed spaces, you'll find everything you need to call Holly Court home.\n\nIndulge in a resort-style living experience with our stunning pool, fully equipped fitness center, and serene sundeck—perfect for relaxing after a long day. Enjoy outdoor gatherings at our picnic area, or savor a delicious BBQ using our grill. Your furry friends are welcome too! Our dog park and pet play area provide ample space for them to roam and play.\n\nInside your apartment, you’ll appreciate features like air conditioning, hardwood floors, and ample storage with walk-in closets. Our apartments are equipped with essential appliances, including a dishwasher and microwave, while convenient laundry facilities and in-unit washer/dryer options make daily chores a breeze. Plus, enjoy high-speed internet access and smoke-free living for a healthy lifestyle.\n\nLocated in the heart of Pitman, NJ, you’ll have easy access to local shops, parks, and recreational spots—everything you need for a fulfilling lifestyle right at your doorstep. With 24-hour maintenance on site and easy access to city conveniences, you can enjoy peace of mind knowing help is always available when you need it.\n\nFind your new home today at Holly Court! Browse our availability or schedule a tour to visit our vibrant community. Your perfect apartment awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-9b50-707e-ad0b-bb64a60c3e70.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, with apartment buildings in the background.",
    "public_id": "019fcdfc-9b50-707e-ad0b-bb64a60c3e70",
    "storage_key": "property/6767906449166928/019fcdfc-9b50-707e-ad0b-bb64a60c3e70.webp",
    "width": 1920,
    "height": 1280
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "188",
  "property_year_built": "1967",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.3404255319149",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Security Deposit: $1000",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Maximum 2 pets per apartment, each up to 100 lb.",
  "property_pet_policy_description": "Cats and dogs are welcome. Maximum 2 pets per apartment, each up to 100 lb. One-time non‑refundable fee: $300 for one pet, $500 for two pets. Monthly pet rent: $50 for the first pet and $25 for the second pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://hollycourt.loftliving.com/login",
  "property_apply_now_url": "https://www.livehollycourt.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026e-0259-7228-b558-687184148bf5.webp",
  "property_primary_logo_media": {
    "alt_text": "Holly Court Apartment Homes logo",
    "public_id": "019d026e-0259-7228-b558-687184148bf5",
    "storage_key": "property/6767906449166928/019d026e-0259-7228-b558-687184148bf5.webp",
    "width": 411,
    "height": 269
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d0270-3c92-728d-95f9-420ba3cfac42.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Holly Court Apartment Homes logo",
    "public_id": "019d0270-3c92-728d-95f9-420ba3cfac42",
    "storage_key": "property/6767906449166928/019d0270-3c92-728d-95f9-420ba3cfac42.webp",
    "width": 411,
    "height": 269
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d0270-45bb-707e-984d-e49dad06ea13.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Holly Court Apartment Homes logo",
    "public_id": "019d0270-45bb-707e-984d-e49dad06ea13",
    "storage_key": "property/6767906449166928/019d0270-45bb-707e-984d-e49dad06ea13.webp",
    "width": 411,
    "height": 269
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
  "property_company_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0264-670c-7240-a629-183122c7de9e",
    "storage_key": "company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
    "width": 598,
    "height": 250
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002142",
  "property_secondary_color": "#494747",
  "property_font_color": "#002142",
  "property_color_4": null,
  "property_color_3": "#f18c20",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "425 - 1000",
  "property_sqft_min": "425",
  "property_sqft_max": "1000",
  "property_price_range": "1640 - 2180",
  "property_price_min": "1640",
  "property_price_max": "2180",
  "property_available_units": 5,
  "property_facebook_url": "https://www.facebook.com/LiveHollyCourt/",
  "property_instagram_url": "https://www.instagram.com/hollycourtapartments/",
  "property_twitter_url": "https://www.twitter.com/hollycourtapts",
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJQ04EVGbXxokR2ib2knjtuys",
  "property_youtube_url": null,
  "property_yelp_url": "https://m.yelp.com/search?find_desc=Apartments&find_loc=Pitman%2C+NJ",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Holly Court",
  "property_home_romance_title": "Embrace Comfort and Connection in Your Ideal Apartment Home",
  "property_home_amenities_blurb": "Nestled in the heart of Pitman, NJ, Holly Court offers a vibrant community where comfort meets convenience. Choose from stylish studio, one, or two-bedroom layouts featuring modern amenities like a refreshing pool, pet-friendly spaces, and an inviting sundeck. Experience the perfect blend of relaxation and sophistication in your new home!",
  "property_home_floorplans_blurb": "At Holly Court in charming Pitman, NJ, we offer a variety of thoughtfully designed floor plans—including cozy studios, spacious one-bedroom, and inviting two-bedroom apartments. Each space is crafted to enhance your lifestyle. Browse our available homes today and find the perfect fit for your unique needs!",
  "property_home_gallery_blurb": "Welcome to Holly Court, your serene retreat in Pitman, NJ! Choose from our thoughtfully designed studio, one, or two-bedroom layouts and enjoy an array of amenities, from a relaxing pool and fitness center to inviting picnic areas and a pet play zone. Picture yourself living here, where comfort meets convenience!",
  "property_home_neighborhood_blurb": "At Holly Court in Pitman, NJ, life's vibrant tapestry unfolds just beyond your doorstep. Enjoy proximity to cultural gems like the Broadway Theatre, the Pitman Historical Museum, and the artistry of the Pitman Gallery. With cozy studios to spacious two-bedroom apartments, your perfect home awaits—come and experience local treasures!",
  "property_home_reviews_blurb": "At Holly Court in Pitman, NJ, residents cherish the welcoming community and exceptional service, with one noting, “You feel right at home from the minute you walk in.” With well-maintained grounds and a friendly staff, we pride ourselves on creating a comfortable living experience for everyone. Come see!",
  "property_neighborhood_blurb": "Nestled in the heart of Pitman, Holly Court connects you to a vibrant tapestry of cultural attractions and local gems. From the enchanting Pitman Gallery & Art Center to the inspiring historical experiences at the Pitman Historical Museum, there's always something to spark your curiosity right outside your door.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Holly Court in Pitman, NJ, experience a lifestyle enhanced by modern comforts and vibrant community spaces. Our apartments feature stylish designs, spacious floor plans, and desirable amenities, including a refreshing pool, state-of-the-art fitness center, and serene picnic areas. Make every day extraordinary with us—your ideal home awaits!",
  "property_applynow_blurb": "At Holly Court in Pitman, NJ, your ideal home awaits with stylish studio to two-bedroom floor plans. Enjoy a vibrant lifestyle with amenities like a pool, dog park, and fitness center. Upgrade your comfort with modern appliances and spacious walk-in closets. Lease online today and make Holly Court your home!",
  "property_contactus_blurb": "At Holly Court in charming Pitman, NJ, our diverse floor plans—ranging from cozy studios to spacious two-bedroom layouts—cater to every lifestyle. Each residence is designed for comfort and convenience. Have questions? Contact our leasing team today to find the perfect fit for you!",
  "property_faqs_blurb": "At Holly Court in charming Pitman, NJ, we offer a variety of floor plans, from cozy studios to spacious two-bedroom apartments, tailored to your lifestyle. Curious about our community? Head to our FAQs page for insights and answers to your pressing questions—your future home awaits!",
  "property_floorplans_blurb": "At Holly Court in Pitman, NJ, a lifestyle of comfort awaits you! Choose from stylish studio, one-bedroom, or two-bedroom layouts designed to fit your needs. Every floor plan offers a unique space to call home. Browse our available apartment homes today and uncover your ideal sanctuary!",
  "property_gallery_blurb": "At Holly Court in Pitman, NJ, picture yourself enjoying tranquil sunny days by the pool and cozy evenings in stylish, pet-friendly apartments. Choose from versatile studio, one, or two-bedroom layouts, all featuring modern comforts like hardwood floors and walk-in closets. Dive into the lifestyle you deserve today!",
  "property_interactivemap_blurb": "Nestled in the heart of Pitman, NJ, Holly Court offers an inviting blend of comfort and convenience. Choose from thoughtfully designed studio to two-bedroom floor plans, and enjoy amenities like a refreshing pool, fitness center, and serene picnic areas. Uncover your ideal living space using our interactive community map!",
  "property_pets_blurb": "At Holly Court in charming Pitman, NJ, your furry friends can thrive! With spacious apartments perfectly suited for up to two pets, we embrace your canine companions and feline family. Enjoy the freedom of pet-friendly living with a vibrant community where every tail gets to wag and every purr feels at home.",
  "property_referafriend_blurb": "At Holly Court in Pitman, NJ, your ideal living space awaits with a range of thoughtfully designed floor plans, from cozy studios to spacious two-bedroom apartments. Great friends make great neighbors—refer a friend today and embrace a vibrant community where shared experiences start right at your doorstep!",
  "property_residentaccess_blurb": "Welcome to Holly Court in charming Pitman, NJ, where comfort meets convenience. With thoughtfully designed studio, one-bedroom, and two-bedroom apartments, you’ll find the perfect home. Residents can easily access the portal to manage rent payments, request maintenance, and enjoy hassle-free living at its finest. Join us today!",
  "property_reviews_blurb": "At Holly Court in Pitman, NJ, residents rave about the community's welcoming atmosphere and attentive staff. With glowing endorsements like “I recommend Holly Court Apartments!” and “You feel right at home from the minute you walk in,” it’s clear why so many choose to call our apartments home. Join our vibrant community today!",
  "property_created_at": "1763476345554",
  "property_scheduletour_blurb": "At Holly Court in Pitman, NJ, choose from inviting studio, one-bedroom, and two-bedroom floor plans designed for modern living. Each space offers comfort and style, perfect for your lifestyle. Curious about our community? Schedule a tour today and hear directly from our residents about their home sweet home experience!",
  "property_thankyou_blurb": "Thank you for reaching out to Holly Court in Pitman, NJ! With a variety of floor plans, including cozy studios and spacious two-bedrooms, we cater to your lifestyle needs. A team member will be in touch soon to guide you toward finding your perfect home at Holly Court.",
  "property_virtualtours_blurb": "Welcome to Holly Court in Pitman, NJ, where modern living meets comfort. Choose from our thoughtfully designed studio, one-bedroom, or two-bedroom floor plans. Experience the inviting ambiance and vibrant community spirit—take a virtual tour to envision your new home today!",
  "property_copyright": "2025 All Rights Reserved. Holly Court",
  "property_seo_title_home": "Holly Court |  Apartments in Pitman, NJ",
  "property_seo_description_home": "Discover Holly Court, Pitman's top apartment community with stylish layouts and delightful amenities—your perfect home is waiting!",
  "property_seo_title_floorplans": "Floor Plans | Pitman, NJ Apartments for Rent",
  "property_seo_description_floorplans": "Uncover your ideal space at Holly Court, Pitman, NJ! From cozy studios to spacious two-bedrooms, find the perfect fit for your lifestyle. Browse now!",
  "property_seo_title_amenities": "Amenities | Pitman, NJ Apartments for Rent",
  "property_seo_description_amenities": "Experience Holly Court in Pitman, NJ—enjoy modern amenities, a pool, fitness center, dog park, and spacious floor plans. Live your best life!",
  "property_seo_title_gallery": "Gallery | Apartments in Pitman, NJ",
  "property_seo_description_gallery": "“Capture the essence of home at Holly Court in Pitman, NJ. Enjoy a vibrant lifestyle with stunning amenities, cozy floor plans, and serene outdoor spaces!”",
  "property_seo_title_virtualtours": "Virtual Tours | Holly Court Apartments",
  "property_seo_description_virtualtours": "Step inside Holly Court in Pitman, NJ! Enjoy our studio, one, and two-bedroom floor plans. Ready to envision your new home? Take the virtual tour now!",
  "property_seo_title_interactivemap": "Interactive Map | Holly Court Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Holly Court in Pitman, NJ! Use our interactive map to explore studio, one, or two-bedroom apartments with top-notch amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Pitman, NJ",
  "property_seo_description_neighborhood": "Uncover Pitman's charm at Holly Court! Dive into local favorites and nearby attractions while enjoying our cozy studio, one, and two-bedroom apartments.",
  "property_seo_title_contact": "Contact Us | Holly Court",
  "property_seo_description_contact": "Find your perfect home at Holly Court in Pitman, NJ. Choose from studio, one, or two-bedroom floor plans. Have questions? Reach out to our leasing team!",
  "property_seo_title_faqs": "FAQs | Apartments in Pitman, NJ",
  "property_seo_description_faqs": "Find answers about Holly Court in Pitman, NJ! From floor plans to amenities, browse our FAQs to discover how we elevate apartment living for you.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Pitman, NJ",
  "property_seo_description_reviews": "Discover life at Holly Court, Pitman, NJ! Explore resident reviews to see why our great amenities and cozy floor plans are perfect for you!",
  "property_seo_title_applynow": "Apply Now | Apartments in Pitman, NJ",
  "property_seo_description_applynow": "Discover modern living at Holly Court in Pitman, NJ! Enjoy spacious layouts, great amenities, and a pet-friendly community. Lease your dream home today!",
  "property_seo_title_residentaccess": "Resident Access | Holly Court",
  "property_seo_description_residentaccess": "Welcome to Holly Court, Pitman, NJ! Access your resident portal for easy rent payments, maintenance requests, and community updates!",
  "property_seo_title_referafriend": "Refer A Friend | Holly Court",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Holly Court in Pitman, NJ, and share the joy of vibrant living in our welcoming community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Holly Court",
  "property_seo_description_scheduletour": "Step into the charm of Holly Court in Pitman, NJ! Schedule a tour today and experience your future home in a vibrant community filled with modern comforts.",
  "property_seo_title_privacy": "Privacy Policy | Holly Court",
  "property_seo_description_privacy": "At Holly Court in Pitman, NJ, your privacy matters. Learn how we protect your information and ensure a safe community experience. View our privacy policy now!",
  "property_seo_title_accessibility": "Website Accessibility | Holly Court",
  "property_seo_description_accessibility": "At Holly Court in Pitman, NJ, we prioritize accessibility and digital inclusion, ensuring a welcoming community for everyone. Join us in making a difference!",
  "property_seo_title_sitemap": "Sitemap | Holly Court",
  "property_seo_description_sitemap": "Navigate your way through Holly Court in Pitman, NJ! Our sitemap makes finding your dream apartment easy. Your next home is just a click away!",
  "property_seo_title_thankyou": "Thank You | Holly Court",
  "property_seo_description_thankyou": "Thank you for reaching out to Holly Court in Pitman, NJ! Our team will connect with you soon to help you find your perfect home. Stay tuned!",
  "property_seo_title_pets": null,
  "property_seo_description_pets": null,
  "property_updated_at": "1791293568438",
  "amenities": [
    {
      "id": "custom_3990b176-ce09-4c1a-8263-ff25f1f6be73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ccea42bd-d608-4548-aa16-0a76e553b16f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f0570d3d-fb16-4be9-b97f-9560c8892169",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rent Payment & Resident Portal",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8e0a9090-6c21-4a3a-b093-8c3155bc8a26",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Laundry Facility",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_af23410e-a26c-40ad-b089-90d50349749e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8554d5a9-503a-4367-9b02-c1079b0bc3f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3b66c1b7-bb25-4268-86d7-c3db9a379d5f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "external_id": "false",
      "title": "Short Term Leases",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bda195bb-bcb6-432f-a030-e3b00f1a7868",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5a9db665-d901-48b7-ac3d-aa0545bd9463",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "external_id": "false",
      "title": "Gas Cooking",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d4944732-40c7-45c0-aad9-953ffb46eecc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "external_id": "false",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e0227e13-3f93-43dc-8889-3fb3cd35c2a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "external_id": "false",
      "title": "Over the Range Microwave*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_708bd5ab-1736-4314-8f93-b5581d1799ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "external_id": "false",
      "title": "Private Entrances",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e204c924-96df-4eee-9f0d-e560788d0bf4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "external_id": "false",
      "title": "Private Patios or Balconies*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_61596194-1410-4e19-a770-3ab511a08b8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliances*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d2710509-ab82-4bba-b729-029ddb22a994",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "external_id": "false",
      "title": "Upgraded Kitchens & Bathrooms*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_52addad3-a47e-4b70-b06c-5274b0dd9bb8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "external_id": "false",
      "title": "Washer & Dryer*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4c4f32cd-8821-458b-8938-e9411752464c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "external_id": "false",
      "title": "Located in Charming Pitman, NJ - voted one of the top 5 downtowns in NJ",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c98aaae2-141a-49d4-9bbc-0763d99adbe9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "external_id": "false",
      "title": "Only 3 Minutes to Rowan University",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_33219f8a-25b9-4589-86e4-39b00f037b15",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "external_id": "false",
      "title": "Walking Distance to Alcyon Lake Park",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f3e7bc3d-b160-44e8-9eaa-b39f2ccaa737",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_068d5687-e663-483e-9335-cf4c2b886b6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "external_id": "false",
      "title": "Free Resident Parking",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1d94b69d-0eb4-45b0-9fc6-a7becaae5fe1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "external_id": "false",
      "title": "Grilling Stations",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_221ee5c9-637c-4f4d-8808-a0f71e8d1a9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "external_id": "false",
      "title": "Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1d3d9433-6216-4186-b09a-b19c53d180a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "external_id": "false",
      "title": "Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_37666aea-a6d2-414c-b93a-9bfd579a08e5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-ae64-75ba-9174-ea111aef90e6.webp",
      "image_media": {
        "alt_text": "Stainless steel refrigerator, gas range, microwave, and dishwasher in a kitchen with dark wood cabinets and a window overlooking trees.",
        "public_id": "019fcdfc-ae64-75ba-9174-ea111aef90e6",
        "storage_key": "property/6767906449166928/019fcdfc-ae64-75ba-9174-ea111aef90e6.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring dark wood cabinetry, stainless steel appliances, and a breakfast bar. Perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "Compact kitchen with dark espresso cabinets, stainless steel fridge, stove, microwave, and a double sink by a window at Holly Court, offers apartments for rent in Pitman, NJ.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/04b28e88/dms3rep/multi/5767906449162442/6767906449166928/c87abcf2cf43fe20b1a75ac286eee429.jpg"
    },
    {
      "id": "custom_da68f7db-7fda-45f9-86b1-3fa5b2512b5c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-ae5d-7099-9cb9-dcd5f6995754.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, closet, and window.",
        "public_id": "019fcdfc-ae5d-7099-9cb9-dcd5f6995754",
        "storage_key": "property/6767906449166928/019fcdfc-ae5d-7099-9cb9-dcd5f6995754.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Neutral-toned apartment bedroom with a gray comforter, multiple pillows, and a dresser by a bright window.",
      "link": "false",
      "alt_text": "Bedroom with gray bedding, dark dresser, and window with blinds at Holly Court, offers apartments for rent in Pitman, NJ.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/04b28e88/dms3rep/multi/5767906449162442/6767906449166928/652130380a4b26d2e1a0ce8f19a72343.webp"
    },
    {
      "id": "custom_2d8bd84b-1e1a-4894-939f-4f83998cd3be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-aebf-778a-8045-aa5d4f4a3cfc.webp",
      "image_media": {
        "alt_text": "Kitchen with stainless steel appliances, dark wood cabinets, and granite countertops.",
        "public_id": "019fcdfc-aebf-778a-8045-aa5d4f4a3cfc",
        "storage_key": "property/6767906449166928/019fcdfc-aebf-778a-8045-aa5d4f4a3cfc.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen featuring granite countertops, dark wood cabinets, stainless steel appliances, and ample storage.",
      "link": "false",
      "alt_text": "Galley-style apartment kitchen with dark wood cabinets, stainless appliances, and granite countertops at Holly Court, offers apartments for rent in Pitman, NJ.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/04b28e88/dms3rep/multi/5767906449162442/6767906449166928/3818ca2f9f43de71915173bb1ada937b.webp"
    },
    {
      "id": "custom_e7c022e4-8d0e-4c17-9b4a-9327e1eae5c2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-aeb4-7580-8bd5-93566eb0f3ab.webp",
      "image_media": {
        "alt_text": "Living room with sofa, armchair, coffee table, dining table, and television.",
        "public_id": "019fcdfc-aeb4-7580-8bd5-93566eb0f3ab",
        "storage_key": "property/6767906449166928/019fcdfc-aeb4-7580-8bd5-93566eb0f3ab.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Step into comfort in this inviting living room, featuring a cozy sofa, a stylish armchair, a convenient coffee table, a dining area, and a modern entertainment setup.",
      "link": "false",
      "alt_text": "Living room in an apartment with sofa, armchair, coffee table, TV, plant, and dining area at Holly Court, offers apartments for rent in Pitman, NJ.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/04b28e88/dms3rep/multi/5767906449162442/6767906449166928/aad09af5a18a74e069b8e18a5344ff93.webp"
    },
    {
      "id": "custom_08934ebd-e2ae-404a-8858-7bd38a420558",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-b9d3-77bf-a5e0-1663ace5c3b8.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019fcdfc-b9d3-77bf-a5e0-1663ace5c3b8",
        "storage_key": "property/6767906449166928/019fcdfc-b9d3-77bf-a5e0-1663ace5c3b8.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Modern galley-style kitchen in a multifamily apartment, featuring granite countertops, stainless steel appliances, and dark wood cabinets.",
      "link": "false",
      "alt_text": "Small galley kitchen with dark wood cabinets, stainless steel fridge, and granite-like countertops at Holly Court, offers apartments for rent in Pitman, NJ.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/04b28e88/dms3rep/multi/5767906449162442/6767906449166928/2c6cb7c8bd54ec195b93509e7a4d8f20.webp"
    },
    {
      "id": "custom_dbc3ae9c-5cc4-4b51-80ca-d536cfb0565e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-bc2b-720f-9ef4-27094697bd08.webp",
      "image_media": {
        "alt_text": "Modern living room with a large TV, sectional sofa, and coffee table.",
        "public_id": "019fcdfc-bc2b-720f-9ef4-27094697bd08",
        "storage_key": "property/6767906449166928/019fcdfc-bc2b-720f-9ef4-27094697bd08.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious living room in a modern apartment with a gray sectional, wooden coffee table, and decorative accents.",
      "link": "false",
      "alt_text": "Living room in an apartment with a large TV, light wood console, and gray sectional at Holly Court, offers apartments for rent in Pitman, NJ.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/04b28e88/dms3rep/multi/5767906449162442/6767906449166928/d3c05136f8a9ede2e913671cf2a008e4.webp"
    },
    {
      "id": "custom_a5e0aa1e-c848-40ff-986e-5fa9dc59c1c1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-bd28-749f-922d-ff209c7c441d.webp",
      "image_media": {
        "alt_text": "Dining area with a round glass table and chairs in front of a gallery wall.",
        "public_id": "019fcdfc-bd28-749f-922d-ff209c7c441d",
        "storage_key": "property/6767906449166928/019fcdfc-bd28-749f-922d-ff209c7c441d.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Cozy dining nook in a modern apartment: round glass table, wooden chairs, and wall art near the compact kitchen.",
      "link": "false",
      "alt_text": "Round glass dining table with wooden chairs in a neutral-toned apartment dining area at Holly Court, offers apartments for rent in Pitman, NJ.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/04b28e88/dms3rep/multi/5767906449162442/6767906449166928/5eaf47fec638620b8f084f49c35cbf0c.webp"
    },
    {
      "id": "custom_55362f87-58c0-47cd-a8c0-348fe59c9376",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-be6c-7617-9069-e2e04ea1c58a.webp",
      "image_media": {
        "alt_text": "Bedroom with a chair, stackable washer and dryer, and a closet.",
        "public_id": "019fcdfc-be6c-7617-9069-e2e04ea1c58a",
        "storage_key": "property/6767906449166928/019fcdfc-be6c-7617-9069-e2e04ea1c58a.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable armchair, stackable washer and dryer, and ample closet space.",
      "link": "false",
      "alt_text": "Bedroom in an apartment with a gray bedspread, seating area, and a laundry closet at Holly Court, offers apartments for rent in Pitman, NJ.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/04b28e88/dms3rep/multi/5767906449162442/6767906449166928/38ea29eb30333af137558d6dca5c8897.webp"
    },
    {
      "id": "custom_704c48cd-2b61-41d0-a6b5-a26c5b427aad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-c52b-75ea-a886-7023b1fe29c0.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white vanity, sink, toilet, and bathtub with a dark shower curtain.",
        "public_id": "019fcdfc-c52b-75ea-a886-7023b1fe29c0",
        "storage_key": "property/6767906449166928/019fcdfc-c52b-75ea-a886-7023b1fe29c0.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom with a tub/shower, white tile surround, gray walls, and a sleek vanity.",
      "link": "false",
      "alt_text": "Bathroom with tub/shower, white tile surround, dark shower curtain, toilet, and sink at Holly Court, offers apartments in Pitman, NJ.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/04b28e88/dms3rep/multi/5767906449162442/6767906449166928/38f38703900a680a51b19db7b6803332.webp"
    },
    {
      "id": "custom_2f747cb1-8749-4439-bd81-77534c93121c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-c7d2-726f-bbe9-be0c4f279c91.webp",
      "image_media": {
        "alt_text": "Tranquil lake surrounded by lush green trees and a bright blue sky.",
        "public_id": "019fcdfc-c7d2-726f-bbe9-be0c4f279c91",
        "storage_key": "property/6767906449166928/019fcdfc-c7d2-726f-bbe9-be0c4f279c91.webp",
        "width": 640,
        "height": 480
      },
      "title": "Community",
      "description": "Tranquil pond framed by trees and green space, showcasing the property's outdoor landscaping and leisure areas.",
      "link": "false",
      "alt_text": "Pond with surrounding trees and grassy banks in a park setting at Holly Court, offers apartments in Pitman, NJ.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/04b28e88/dms3rep/multi/5767906449162442/6767906449166928/e979b9c10278da5c3efd07e3ae094f65.jpg"
    },
    {
      "id": "custom_c2c20703-d62c-4bd5-ad73-5e59c9b6dd14",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-ca4c-740b-90d9-151c94f336b0.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas",
        "public_id": "019fcdfc-ca4c-740b-90d9-151c94f336b0",
        "storage_key": "property/6767906449166928/019fcdfc-ca4c-740b-90d9-151c94f336b0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Bright outdoor pool area at a residential apartment community with lounge chairs, red umbrellas, and surrounding greenery.",
      "link": "false",
      "alt_text": "Outdoor apartment pool area with lounge chairs, tables under red umbrellas, and trees at Holly Court, offers apartments near downtown Pitman, NJ.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/04b28e88/dms3rep/multi/5767906449162442/6767906449166928/91c98e84e31e5314a98623053369c484.webp"
    },
    {
      "id": "custom_469942a1-9a63-4ab6-a259-fccf0811a830",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-cbd4-71de-a825-89d1465501b9.webp",
      "image_media": {
        "alt_text": "Resort-style outdoor swimming pool with lounge chairs and umbrellas",
        "public_id": "019fcdfc-cbd4-71de-a825-89d1465501b9",
        "storage_key": "property/6767906449166928/019fcdfc-cbd4-71de-a825-89d1465501b9.webp",
        "width": 1666,
        "height": 1112
      },
      "title": "Community",
      "description": "Enjoy our resort-style outdoor swimming pool, perfect for relaxing and soaking up the sun. Plenty of lounge chairs and umbrellas available.",
      "link": "false",
      "alt_text": "Outdoor pool with lounge chairs and red umbrellas, surrounded by trees at Holly Court, offers apartments near downtown Pitman, NJ.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/04b28e88/dms3rep/multi/5767906449162442/6767906449166928/6603370f5b4e02a1cbe1cfba4e5becf0.jpg"
    },
    {
      "id": "custom_2fa80c1a-9222-4ec4-8ede-09fb4cf30500",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-d220-77bb-9bdb-4adcf83d624c.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, weight machines, and benches.",
        "public_id": "019fcdfc-d220-77bb-9bdb-4adcf83d624c",
        "storage_key": "property/6767906449166928/019fcdfc-d220-77bb-9bdb-4adcf83d624c.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Well-equipped resident gym with cardio and strength equipment, mirrors, and natural light for convenient workouts.",
      "link": "false",
      "alt_text": "Bright community fitness center featuring treadmills, weight machines, and a mirrored wall at Holly Court, offers apartments near downtown Pitman, NJ.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/04b28e88/dms3rep/multi/5767906449162442/6767906449166928/94ed9ca1f4af32344bc1fcb11fdacd28.jpg"
    },
    {
      "id": "custom_6453d0b3-c2a8-4c77-86cd-81b6761a584b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-d244-75ca-9491-d92dc7713a37.webp",
      "image_media": {
        "alt_text": "Treadmills, elliptical, and weight machine in a fitness center with brick accent wall.",
        "public_id": "019fcdfc-d244-75ca-9491-d92dc7713a37",
        "storage_key": "property/6767906449166928/019fcdfc-d244-75ca-9491-d92dc7713a37.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring cardio machines and strength training equipment.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, elliptical, and weight machines against a brick wall at Holly Court, offers apartments near Rowan University.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/04b28e88/dms3rep/multi/5767906449162442/6767906449166928/a0f441e642f9b5267c1c116dccabec78.jpg"
    },
    {
      "id": "custom_a069dc98-be43-4fc6-9138-63456391318b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-d81e-762b-a646-69eca7ad9cef.webp",
      "image_media": {
        "alt_text": "Covered outdoor patio with picnic tables and a built-in grill.",
        "public_id": "019fcdfc-d81e-762b-a646-69eca7ad9cef",
        "storage_key": "property/6767906449166928/019fcdfc-d81e-762b-a646-69eca7ad9cef.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Outdoor community gathering area with a covered pavilion, built-in grill, and seating.",
      "link": "false",
      "alt_text": "Covered wooden pavilion with metal picnic tables and a built-in grill at Holly Court, offers apartments in Pitman, NJ.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/04b28e88/dms3rep/multi/5767906449162442/6767906449166928/47b1c9f38aa06f64260f13a44257ea9a.jpg"
    },
    {
      "id": "custom_dbe5c875-f646-48d0-9618-29a319a9586b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-d927-771f-b24f-d5b55c09533a.webp",
      "image_media": {
        "alt_text": "Exterior of a brick apartment building with balconies and front doors.",
        "public_id": "019fcdfc-d927-771f-b24f-d5b55c09533a",
        "storage_key": "property/6767906449166928/019fcdfc-d927-771f-b24f-d5b55c09533a.webp",
        "width": 1637,
        "height": 1093
      },
      "title": "Community",
      "description": "The exterior of a two-story brick apartment building featuring balconies, multiple entrances, and well-maintained landscaping.",
      "link": "false",
      "alt_text": "Two-story brick apartment building exterior with doors, balconies, and a green lawn at Holly Court, offers apartments in Pitman, NJ.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/04b28e88/dms3rep/multi/5767906449162442/6767906449166928/5f616296a42bd6da5b047670b68dd403.jpg"
    },
    {
      "id": "custom_5dd0c2b0-36bb-4882-a678-8d6d8f9f2fec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-de62-741e-96d0-ccb5646cdf4b.webp",
      "image_media": {
        "alt_text": "Covered patio area with seating and picnic tables, exterior of apartment building.",
        "public_id": "019fcdfc-de62-741e-96d0-ccb5646cdf4b",
        "storage_key": "property/6767906449166928/019fcdfc-de62-741e-96d0-ccb5646cdf4b.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Exterior view of a multifamily community showing a covered porch, brick accents, and outdoor seating near the entrance.",
      "link": "false",
      "alt_text": "Covered front porch of an apartment building with white columns, brick bases, and outdoor seating at Holly Court, offers apartments in Pitman, NJ.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/04b28e88/dms3rep/multi/5767906449162442/6767906449166928/9c9a45b13df6e67b2408201711f20aac.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_492846df-76f3-4916-9f45-3ec6a6b17ea9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "George's Family Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "466 W Holly Ave, Pitman, NJ 08071, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-f427-726e-a666-c1fe989e79d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfc-f427-726e-a666-c1fe989e79d0",
        "storage_key": "property/6767906449166928/019fcdfc-f427-726e-a666-c1fe989e79d0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.georgesfamily-restaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3824843973818290748&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georges-family-restaurant",
      "poi_latitude": "39.7321661",
      "poi_longitude": "-75.14029649999999",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 856-221-4911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-031c-71ed-8a13-01253bf9806a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-031c-71ed-8a13-01253bf9806a",
        "storage_key": "property/6767906449166928/019d026f-031c-71ed-8a13-01253bf9806a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHRtrE5jXxokRPJK7TFSTFDU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f1f31c34-b13e-46a6-b370-e2f926da0edb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Endgrain Coffee Roasters",
      "poi_type": "Restaurants",
      "poi_address": "10 Pitman Ave, Pitman, NJ 08071, USA",
      "poi_short_description": "Neighborhood favorite for local coffee and espresso that roasts its own beans.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-f343-72f7-adea-44f90f17d588.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfc-f343-72f7-adea-44f90f17d588",
        "storage_key": "property/6767906449166928/019fcdfc-f343-72f7-adea-44f90f17d588.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "http://store.endgrain.coffee/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14569157490953913266&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "endgrain-coffee-roasters",
      "poi_latitude": "39.7319862",
      "poi_longitude": "-75.1297963",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 856-553-8887",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-0312-723f-82f9-ca467e293070.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-0312-723f-82f9-ca467e293070",
        "storage_key": "property/6767906449166928/019d026f-0312-723f-82f9-ca467e293070.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJuwnaNxXXxokRsoMHHYwLMMo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_00dd29a0-d8f2-4794-8ac1-dbabaaaedd71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Chloe's Creme Puffs",
      "poi_type": "Restaurants",
      "poi_address": "7 E Holly Ave, Pitman, NJ 08071, USA",
      "poi_short_description": "Casual bakery specializing in crèmepuffs, with flavors like vanilla and chocolate.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-f33c-760b-95ff-b5ea27c7cc00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfc-f33c-760b-95ff-b5ea27c7cc00",
        "storage_key": "property/6767906449166928/019fcdfc-f33c-760b-95ff-b5ea27c7cc00.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.chloescremepuffs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7591351794860694305&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chloes-creme-puffs",
      "poi_latitude": "39.7332915",
      "poi_longitude": "-75.1310029",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 856-589-2919",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-031c-71ed-8a13-01253bf9806a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-031c-71ed-8a13-01253bf9806a",
        "storage_key": "property/6767906449166928/019d026f-031c-71ed-8a13-01253bf9806a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8ZhYVBXXxokRIRuymTzmWWk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_70200765-fa27-4524-9c68-b848339037a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Dia De Los Burritos",
      "poi_type": "Restaurants",
      "poi_address": "24 Pitman Ave, Pitman, NJ 08071, USA",
      "poi_short_description": "Casual eatery dishing out a menu of tacos, burritos, bowls and quesadillas from fresh ingredients.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-f400-7528-ab7c-86865509fc3b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfc-f400-7528-ab7c-86865509fc3b",
        "storage_key": "property/6767906449166928/019fcdfc-f400-7528-ab7c-86865509fc3b.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.diadelosburritos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11614882625885675035&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dia-de-los-burritos",
      "poi_latitude": "39.7319983",
      "poi_longitude": "-75.12939639999999",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 856-582-0932",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-031c-71ed-8a13-01253bf9806a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-031c-71ed-8a13-01253bf9806a",
        "storage_key": "property/6767906449166928/019d026f-031c-71ed-8a13-01253bf9806a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBdd9ExXXxokRG57FvzVaMKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4e0c29a4-f6a9-42a9-ae89-19ba4938ce5a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Mama Marie's Italian Market",
      "poi_type": "Restaurants",
      "poi_address": "29 S Broadway, Pitman, NJ 08071, USA",
      "poi_short_description": "Sandwich shop also serving salads, bagels and hot breakfast sandwiches.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-fade-762c-864d-353d9b34238c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfc-fade-762c-864d-353d9b34238c",
        "storage_key": "property/6767906449166928/019fcdfc-fade-762c-864d-353d9b34238c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://mamamariesitalianmarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=664125262924244298&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mama-maries-italian-market",
      "poi_latitude": "39.7325697",
      "poi_longitude": "-75.1308169",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 856-589-4440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-031c-71ed-8a13-01253bf9806a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-031c-71ed-8a13-01253bf9806a",
        "storage_key": "property/6767906449166928/019d026f-031c-71ed-8a13-01253bf9806a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8_L5TxXXxokRSmX2bmhyNwk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ba19d385-903b-4e4b-b397-58e703cd9de4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Sweet Lula's American Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "28 S Broadway, Pitman, NJ 08071, USA",
      "poi_short_description": "Easygoing BYOB restaurant serving New American cooking with a global twist amid warm surrounds.",
      "poi_long_description": "Easygoing BYOB restaurant serving New American cooking with a global twist amid warm surrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-fb5e-77f6-bcf8-0943524ff3c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfc-fb5e-77f6-bcf8-0943524ff3c4",
        "storage_key": "property/6767906449166928/019fcdfc-fb5e-77f6-bcf8-0943524ff3c4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.sweetlulas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8093335616620259650&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sweet-lulas-american-restaurant",
      "poi_latitude": "39.732401",
      "poi_longitude": "-75.13107099999999",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 856-589-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-031c-71ed-8a13-01253bf9806a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-031c-71ed-8a13-01253bf9806a",
        "storage_key": "property/6767906449166928/019d026f-031c-71ed-8a13-01253bf9806a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ11kmSxXXxokRQumq7NxNUXA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7e5f1089-57d5-4140-ab88-d0c8d4eab69f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Alaura Homemade Ice Cream",
      "poi_type": "Restaurants",
      "poi_address": "36 S Broadway, Pitman, NJ 08071, USA",
      "poi_short_description": "Lively spot for homemade ice cream in a variety of creative flavors, plus a menu of grilled cheeses and hot dogs.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-fabd-708f-8ba3-49fc56c96479.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfc-fabd-708f-8ba3-49fc56c96479",
        "storage_key": "property/6767906449166928/019fcdfc-fabd-708f-8ba3-49fc56c96479.webp",
        "width": 960,
        "height": 960
      },
      "poi_business_url": "http://www.alauraicecream.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13049930887637221370&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaura-homemade-ice-cream",
      "poi_latitude": "39.7322113",
      "poi_longitude": "-75.1308773",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 856-589-3845",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-031c-71ed-8a13-01253bf9806a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-031c-71ed-8a13-01253bf9806a",
        "storage_key": "property/6767906449166928/019d026f-031c-71ed-8a13-01253bf9806a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJsxaKNRXXxokR-r8DNQCrGrU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a5795d74-11d1-4522-b951-596487c5bd24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Lucia's Bistro",
      "poi_type": "Restaurants",
      "poi_address": "148 S Broadway, Pitman, NJ 08071, USA",
      "poi_short_description": "Casual restaurant serving an Italian-American menu with breakfast, sandwiches, and homemade desserts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-fc22-74ca-aaab-07ae52332aae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfc-fc22-74ca-aaab-07ae52332aae",
        "storage_key": "property/6767906449166928/019fcdfc-fc22-74ca-aaab-07ae52332aae.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.luciasbistro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8694345458219693562&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lucias-bistro",
      "poi_latitude": "39.730451",
      "poi_longitude": "-75.1292033",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 856-270-8373",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-031c-71ed-8a13-01253bf9806a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-031c-71ed-8a13-01253bf9806a",
        "storage_key": "property/6767906449166928/019d026f-031c-71ed-8a13-01253bf9806a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJG7EHQlvXxokR-jW3LyGFqHg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_51e0bc7b-8207-444e-b546-470de5453aed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Attilio's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "68 S Broadway, Pitman, NJ 08071, USA",
      "poi_short_description": "Casual pizzeria known for thin-crust pies, pasta and gluten-free fare, plus friendly service.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-0128-73d9-83d6-62f5ff14016c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-0128-73d9-83d6-62f5ff14016c",
        "storage_key": "property/6767906449166928/019fcdfd-0128-73d9-83d6-62f5ff14016c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.attiliospizzaandpasta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13880461451113813956&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "attilios-pizza",
      "poi_latitude": "39.7316139",
      "poi_longitude": "-75.13028059999999",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 856-270-2033",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-031c-71ed-8a13-01253bf9806a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-031c-71ed-8a13-01253bf9806a",
        "storage_key": "property/6767906449166928/019d026f-031c-71ed-8a13-01253bf9806a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9c3sOhXXxokRxFck4CVOocA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f4f1f9ac-350e-45a4-8aec-9b03e73c7f62",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "The Gentle Giant Cafe",
      "poi_type": "Restaurants",
      "poi_address": "13 S Broadway, Pitman, NJ 08071, USA",
      "poi_short_description": "Casual eatery offering vegan sandwiches and burgers, along with coffee and sweets.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-0170-7435-850f-122c2e563e2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-0170-7435-850f-122c2e563e2c",
        "storage_key": "property/6767906449166928/019fcdfd-0170-7435-850f-122c2e563e2c.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://thegentlegiantcafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=125434411056973442&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-gentle-giant-cafe",
      "poi_latitude": "39.7328931",
      "poi_longitude": "-75.1310012",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 856-956-3877",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-031c-71ed-8a13-01253bf9806a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-031c-71ed-8a13-01253bf9806a",
        "storage_key": "property/6767906449166928/019d026f-031c-71ed-8a13-01253bf9806a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJE7MTXSvXxokRgkapqe6hvQE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d3ae4a01-b87a-4057-89e3-7a56b1e85632",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Martini’s on Broadway",
      "poi_type": "Restaurants",
      "poi_address": "47 S Broadway, Pitman, NJ 08071, USA",
      "poi_short_description": "Relaxed, bar-focused eatery featuring specialty cocktails, including martini variations, plus steaks, burgers and flatbreads.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-030e-77cf-8f0f-237953b5ae49.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-030e-77cf-8f0f-237953b5ae49",
        "storage_key": "property/6767906449166928/019fcdfd-030e-77cf-8f0f-237953b5ae49.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://martinisonbroadway.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5900061499430451166&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "martinis-on-broadway",
      "poi_latitude": "39.7322605",
      "poi_longitude": "-75.1303892",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 856-553-6856",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-031c-71ed-8a13-01253bf9806a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-031c-71ed-8a13-01253bf9806a",
        "storage_key": "property/6767906449166928/019d026f-031c-71ed-8a13-01253bf9806a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJg9Idlc_XxokR3reCgqw64VE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3c428efd-1481-4945-a7f6-8d752a785c3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Merryman's Pub",
      "poi_type": "Restaurants",
      "poi_address": "106 S Broadway, Pitman, NJ 08071, USA",
      "poi_short_description": "Charming restaurant (casual, trendy ambiance) serving fried eats, pizzas, burgers, sandwiches, burgers and a full bar.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-03b2-7617-896e-9b2859b0b7e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-03b2-7617-896e-9b2859b0b7e2",
        "storage_key": "property/6767906449166928/019fcdfd-03b2-7617-896e-9b2859b0b7e2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://merrymanspub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5389492037261602636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "merrymans-pub",
      "poi_latitude": "39.7314432",
      "poi_longitude": "-75.1301086",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 856-270-2253",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-031c-71ed-8a13-01253bf9806a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-031c-71ed-8a13-01253bf9806a",
        "storage_key": "property/6767906449166928/019d026f-031c-71ed-8a13-01253bf9806a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1QAVgRHXxokRTC_GAHRSy0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d038c783-efb4-4b15-85af-59c8ae06321e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Pizzeria Manninos",
      "poi_type": "Restaurants",
      "poi_address": "170 S Broadway, Pitman, NJ 08071, USA",
      "poi_short_description": "Pizzeria with a wood-fired oven turning out pies and garlic knots, plus gelato, in a casual setting.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-07c1-72ac-bd22-e675d0444bdf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-07c1-72ac-bd22-e675d0444bdf",
        "storage_key": "property/6767906449166928/019fcdfd-07c1-72ac-bd22-e675d0444bdf.webp",
        "width": 1280,
        "height": 923
      },
      "poi_business_url": "https://pizzeriamanninosnj.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14407501903737554763&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pizzeria-manninos",
      "poi_latitude": "39.730089",
      "poi_longitude": "-75.128838",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 856-716-6366",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-031c-71ed-8a13-01253bf9806a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-031c-71ed-8a13-01253bf9806a",
        "storage_key": "property/6767906449166928/019d026f-031c-71ed-8a13-01253bf9806a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJyQB48BTXxokRS4cKsaW68cc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1850e931-a641-4606-8434-bb03894bd631",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Nine Thai Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "7 S Broadway, Pitman, NJ 08071, USA",
      "poi_short_description": "Thai restaurant dishing up comfort food including vegetarian and vegan options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-0858-77f3-b304-a406c1c25810.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-0858-77f3-b304-a406c1c25810",
        "storage_key": "property/6767906449166928/019fcdfd-0858-77f3-b304-a406c1c25810.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://www.ninethaicuisine.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2157773394729474645&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nine-thai-cuisine",
      "poi_latitude": "39.7330876",
      "poi_longitude": "-75.1311418",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 856-270-2481",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-031c-71ed-8a13-01253bf9806a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-031c-71ed-8a13-01253bf9806a",
        "storage_key": "property/6767906449166928/019d026f-031c-71ed-8a13-01253bf9806a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJETkl66HXxokRVZqjWnjz8R0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_268a01de-1d78-4731-ae92-d0ca7a7ac594",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Neck of the Woods Brewing",
      "poi_type": "Restaurants",
      "poi_address": "614 Lambs Rd #7, Pitman, NJ 08071, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-0a67-7150-baa0-4876dfc20aad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-0a67-7150-baa0-4876dfc20aad",
        "storage_key": "property/6767906449166928/019fcdfd-0a67-7150-baa0-4876dfc20aad.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://neckofthewoodsbrewing.square.site/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14750974033819824410&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "neck-of-the-woods-brewing",
      "poi_latitude": "39.7397151",
      "poi_longitude": "-75.14540629999999",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 856-553-6275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-02a8-704a-9749-59d87b256fe9",
        "storage_key": "property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPUCjjlzXxokRGnHX0Lr8tcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0254aece-95bb-4233-8a30-c5e24a5afe35",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Pitman Pharmacy",
      "poi_type": "Shopping",
      "poi_address": "39 S Broadway, Pitman, NJ 08071, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-0aad-76ba-9aa0-0644abb0672c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-0aad-76ba-9aa0-0644abb0672c",
        "storage_key": "property/6767906449166928/019fcdfd-0aad-76ba-9aa0-0644abb0672c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.pitmanpharmacy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8631502652286465318&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pitman-pharmacy",
      "poi_latitude": "39.732417",
      "poi_longitude": "-75.1305436",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 856-589-2392",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-02aa-73fb-9f52-8f48727e1ac8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-02aa-73fb-9f52-8f48727e1ac8",
        "storage_key": "property/6767906449166928/019d026f-02aa-73fb-9f52-8f48727e1ac8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh_lVSBXXxokRJnVgO-5ByXc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d141a0f4-4631-4307-8213-01c6737933b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Shopping",
      "poi_address": "1060 Delsea Dr BLDG. 3, Glassboro, NJ 08028, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-0e67-77e9-8c9d-bce6cacde628.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-0e67-77e9-8c9d-bce6cacde628",
        "storage_key": "property/6767906449166928/019fcdfd-0e67-77e9-8c9d-bce6cacde628.webp",
        "width": 1280,
        "height": 680
      },
      "poi_business_url": "https://www.cvs.com/store-locator/glassboro-nj-pharmacies/1060-north-delsea-drive-bldg-3-glassboro-nj-08028/storeid=855?WT.mc_id=LS_GOOGLE_FS_855",
      "poi_directions_map_url": "https://maps.google.com/?cid=3651686571019204703&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "39.7239204",
      "poi_longitude": "-75.1148755",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 856-582-0020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-02a8-704a-9749-59d87b256fe9",
        "storage_key": "property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJneXZChvXxokRX_ipwJZlrTI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_daa928bc-ca6c-4b26-b495-18b1d9ebbf03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping",
      "poi_address": "812 Delsea Dr, Glassboro, NJ 08028, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-0f78-7205-853e-9d34f60ea0d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-0f78-7205-853e-9d34f60ea0d2",
        "storage_key": "property/6767906449166928/019fcdfd-0f78-7205-853e-9d34f60ea0d2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://stores.aldi.us/nj/glassboro/812-n-delsea-dr?utm_source=google&utm_medium=local&utm_campaign=brand&utm_content=storepage_webclick",
      "poi_directions_map_url": "https://maps.google.com/?cid=5659082332900128110&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "39.7208703",
      "poi_longitude": "-75.1122701",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-06ec-7082-80f5-c156468bb80d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-06ec-7082-80f5-c156468bb80d",
        "storage_key": "property/6767906449166928/019d026f-06ec-7082-80f5-c156468bb80d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ29BfSwPXxokRbnUzD2YZiU4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b91912a9-319f-425f-a8b6-c8c3eb86f015",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "ShopRite of Glassboro",
      "poi_type": "Shopping",
      "poi_address": "201 William Dalton Dr, Glassboro, NJ 08028, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-114b-74cc-af0d-e433d266fc84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-114b-74cc-af0d-e433d266fc84",
        "storage_key": "property/6767906449166928/019fcdfd-114b-74cc-af0d-e433d266fc84.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.shoprite.com/?utm_source=GMB&utm_medium=Local_Search&utm_campaign=dbaPlatform&utm_term=554",
      "poi_directions_map_url": "https://maps.google.com/?cid=15646024382427476148&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shoprite-of-glassboro",
      "poi_latitude": "39.7191863",
      "poi_longitude": "-75.1094754",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 856-863-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-06ec-7082-80f5-c156468bb80d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-06ec-7082-80f5-c156468bb80d",
        "storage_key": "property/6767906449166928/019d026f-06ec-7082-80f5-c156468bb80d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB0yetgLXxokRtLCwlUfYIdk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_49be6ea2-c565-4efd-b6ca-90010dbb8a54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Wawa",
      "poi_type": "Shopping",
      "poi_address": "485 Woodbury Glassboro Rd, Sewell, NJ 08080, USA",
      "poi_short_description": "Convenience store chain known for sandwiches & coffee. Many offer fuel & are open 24/7.",
      "poi_long_description": "Convenience store chain known for sandwiches & coffee. Many offer fuel & are open 24/7.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-10c8-73d8-b502-54535238bdf5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-10c8-73d8-b502-54535238bdf5",
        "storage_key": "property/6767906449166928/019fcdfd-10c8-73d8-b502-54535238bdf5.webp",
        "width": 500,
        "height": 400
      },
      "poi_business_url": "https://www.wawa.com/locations/8403?utm_source=gmblisting&utm_medium=organic&utm_campaign=locallisting",
      "poi_directions_map_url": "https://maps.google.com/?cid=11751629282370107361&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wawa",
      "poi_latitude": "39.7493162",
      "poi_longitude": "-75.126307",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 856-258-0407",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-031c-71ed-8a13-01253bf9806a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-031c-71ed-8a13-01253bf9806a",
        "storage_key": "property/6767906449166928/019d026f-031c-71ed-8a13-01253bf9806a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2zAbvdnXxokR4be_y5EsFqM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d723a468-e99a-4dce-ae58-f2eaba20033b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping",
      "poi_address": "340 N Broadway, Pitman, NJ 08071, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-147a-75ad-8b7c-dfc04bcdb3f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-147a-75ad-8b7c-dfc04bcdb3f7",
        "storage_key": "property/6767906449166928/019fcdfd-147a-75ad-8b7c-dfc04bcdb3f7.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://www.7-eleven.com/locations/nj/pitman/340-n-broadway-ave.-11008?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=4329548636310987407&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "39.7358832",
      "poi_longitude": "-75.134609",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 856-582-0804",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-06fa-73aa-a0f6-8631cd56e340.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-06fa-73aa-a0f6-8631cd56e340",
        "storage_key": "property/6767906449166928/019d026f-06fa-73aa-a0f6-8631cd56e340.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ65QqrkHXxokRj-IXuYulFTw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_66642852-d77b-46e5-a532-0e33590f4875",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Maggie Paige Boutique",
      "poi_type": "Shopping",
      "poi_address": "30 S Broadway, Pitman, NJ 08071, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-1698-7369-9503-b6f26fb0e0d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-1698-7369-9503-b6f26fb0e0d6",
        "storage_key": "property/6767906449166928/019fcdfd-1698-7369-9503-b6f26fb0e0d6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://maggiepaigeboutique.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18419902051482236409&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maggie-paige-boutique",
      "poi_latitude": "39.7323815",
      "poi_longitude": "-75.130922",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 856-269-4816",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-0751-7277-b31b-fd884d385c72.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-0751-7277-b31b-fd884d385c72",
        "storage_key": "property/6767906449166928/019d026f-0751-7277-b31b-fd884d385c72.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ-5eDCdLXxokR-XUWsFKjoP8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_716e382b-c8cd-495a-a238-23193821704f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Crossroad Comics and Collectibles",
      "poi_type": "Shopping",
      "poi_address": "23 S Broadway, Pitman, NJ 08071, USA",
      "poi_short_description": "Friendly, helpful shop stocking comic books (including back issues) and toys.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-17db-711e-9c97-d0af26041c74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-17db-711e-9c97-d0af26041c74",
        "storage_key": "property/6767906449166928/019fcdfd-17db-711e-9c97-d0af26041c74.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.crossroadcomics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16782701561545548812&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossroad-comics-and-collectibles",
      "poi_latitude": "39.7327066",
      "poi_longitude": "-75.130905",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 856-582-0396",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-0751-7277-b31b-fd884d385c72.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-0751-7277-b31b-fd884d385c72",
        "storage_key": "property/6767906449166928/019d026f-0751-7277-b31b-fd884d385c72.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJF7hlTBXXxokRDORQ0yYi6Og",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_783516b7-fa31-41cf-a3ac-3af5279ee101",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "120 N Broadway",
      "poi_type": "Shopping",
      "poi_address": "120 N Broadway, Pitman, NJ 08071, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8997844113838277148&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "120-n-broadway",
      "poi_latitude": "39.7343865",
      "poi_longitude": "-75.13302259999999",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-02a8-704a-9749-59d87b256fe9",
        "storage_key": "property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGwdTI0DXxokRHIKrhYzD3nw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_66ec34cb-a269-4b39-b2c1-1a7616fa4ba7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Uptown Antiques",
      "poi_type": "Shopping",
      "poi_address": "67 S Broadway, Pitman, NJ 08071, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-18a2-7708-affa-fc7d3aaa7ef8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-18a2-7708-affa-fc7d3aaa7ef8",
        "storage_key": "property/6767906449166928/019fcdfd-18a2-7708-affa-fc7d3aaa7ef8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://uptownantiquespitman.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13901663942916393712&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uptown-antiques",
      "poi_latitude": "39.7318416",
      "poi_longitude": "-75.1300471",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 609-217-6188",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-0751-7277-b31b-fd884d385c72.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-0751-7277-b31b-fd884d385c72",
        "storage_key": "property/6767906449166928/019d026f-0751-7277-b31b-fd884d385c72.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJAeOumwrXxokR8EpjsLOh7MA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d3b2f765-d923-4bce-941a-64d79bc6de45",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Pitman Jr./Sr. High School",
      "poi_type": "Education",
      "poi_address": "225 Linden Ave, Pitman, NJ 08071, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-1b5e-7305-88fa-70df1866aecc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-1b5e-7305-88fa-70df1866aecc",
        "storage_key": "property/6767906449166928/019fcdfd-1b5e-7305-88fa-70df1866aecc.webp",
        "width": 925,
        "height": 1280
      },
      "poi_business_url": "http://pitman.k12.nj.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1715805415590132726&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pitman-jrsr-high-school",
      "poi_latitude": "39.7406336",
      "poi_longitude": "-75.12708239999999",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 856-589-2121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-0753-779e-8715-bd7fd9766d2e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-0753-779e-8715-bd7fd9766d2e",
        "storage_key": "property/6767906449166928/019d026f-0753-779e-8715-bd7fd9766d2e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVW9UnDnXxokR9vvwS-_Dzxc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1ee9f302-5152-4bcf-9ad0-dbf54f09938a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Pitman Elementary School",
      "poi_type": "Education",
      "poi_address": "138 E Holly Ave, Pitman, NJ 08071, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://pitman.k12.nj.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1810058764163512090&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pitman-elementary-school",
      "poi_latitude": "39.7351978",
      "poi_longitude": "-75.1274652",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 856-589-0636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-0753-779e-8715-bd7fd9766d2e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-0753-779e-8715-bd7fd9766d2e",
        "storage_key": "property/6767906449166928/019d026f-0753-779e-8715-bd7fd9766d2e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZ7dc-j7XxokRGneMHNueHhk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_458f25fb-c765-4f50-af68-ffc14a2831de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Memorial Elementary School",
      "poi_type": "Education",
      "poi_address": "400 Hudson Ave, Pitman, NJ 08071, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://mes.pitman.k12.nj.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13216069133048163541&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-elementary-school",
      "poi_latitude": "39.7345333",
      "poi_longitude": "-75.1397693",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 856-589-2526",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-0753-779e-8715-bd7fd9766d2e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-0753-779e-8715-bd7fd9766d2e",
        "storage_key": "property/6767906449166928/019d026f-0753-779e-8715-bd7fd9766d2e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrVC5n1nXxokR1SxX0troaLc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8b292eba-94b6-4471-a584-d80f79d08443",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Pitman School Superintendent",
      "poi_type": "Education",
      "poi_address": "420 Hudson Ave, Pitman, NJ 08071, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.pitman.k12.nj.us/our-district/superintendent",
      "poi_directions_map_url": "https://maps.google.com/?cid=16115725289596191938&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pitman-school-superintendent",
      "poi_latitude": "39.73467230000001",
      "poi_longitude": "-75.14012439999999",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 856-589-2145",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-0753-779e-8715-bd7fd9766d2e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-0753-779e-8715-bd7fd9766d2e",
        "storage_key": "property/6767906449166928/019d026f-0753-779e-8715-bd7fd9766d2e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJt9SwLWjXxokRwgQpIMSOpt8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fb120698-0ce5-4c0f-827f-6cd1a91dd608",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "First Presbyterian Church",
      "poi_type": "Education",
      "poi_address": "10 Wildwood Ave, Pitman, NJ 08071, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-1d97-7192-ab44-f9f1816e39bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-1d97-7192-ab44-f9f1816e39bb",
        "storage_key": "property/6767906449166928/019fcdfd-1d97-7192-ab44-f9f1816e39bb.webp",
        "width": 1280,
        "height": 1266
      },
      "poi_business_url": "http://www.pitmanpres.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8161650470918835662&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "first-presbyterian-church",
      "poi_latitude": "39.7288572",
      "poi_longitude": "-75.12691149999999",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 856-589-1050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-0b15-771b-b1a7-3d0b3c7542bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-0b15-771b-b1a7-3d0b3c7542bd",
        "storage_key": "property/6767906449166928/019d026f-0b15-771b-b1a7-3d0b3c7542bd.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJY7XuEhTXxokRzk0EbNwBRHE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cc0bac8b-0308-4a50-94ed-62957c6d5d3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Bright Beginnings West Private Preschool",
      "poi_type": "Education",
      "poi_address": "536 Lambs Rd, Pitman, NJ 08071, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-1ec0-76ef-9e7f-c2f81143ce31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-1ec0-76ef-9e7f-c2f81143ce31",
        "storage_key": "property/6767906449166928/019fcdfd-1ec0-76ef-9e7f-c2f81143ce31.webp",
        "width": 600,
        "height": 400
      },
      "poi_business_url": "http://www.brightbeginningswest.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17135691285233207353&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bright-beginnings-west-private-preschool",
      "poi_latitude": "39.7397903",
      "poi_longitude": "-75.1409637",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 856-256-1166",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-0753-779e-8715-bd7fd9766d2e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-0753-779e-8715-bd7fd9766d2e",
        "storage_key": "property/6767906449166928/019d026f-0753-779e-8715-bd7fd9766d2e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvyq_n0TXxokROQgVZW80zu0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_43c5c72d-b3b8-4134-8723-433cc33f905d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "ABC Express Pre-School LLC",
      "poi_type": "Education",
      "poi_address": "697 Delsea Dr, Pitman, NJ 08071, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-1f3a-74a7-8aec-ffbff3dcc7a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-1f3a-74a7-8aec-ffbff3dcc7a4",
        "storage_key": "property/6767906449166928/019fcdfd-1f3a-74a7-8aec-ffbff3dcc7a4.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8799308234930960078&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "abc-express-pre-school-llc",
      "poi_latitude": "39.7398016",
      "poi_longitude": "-75.1138563",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 856-589-0826",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-0753-779e-8715-bd7fd9766d2e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-0753-779e-8715-bd7fd9766d2e",
        "storage_key": "property/6767906449166928/019d026f-0753-779e-8715-bd7fd9766d2e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXayv3iXXxokRzrY6DDhsHXo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_79d2b4ff-6fd8-4f9a-89c8-021ebb8769a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Our Father's House at Pitman United Methodist Church",
      "poi_type": "Education",
      "poi_address": "758 N Broadway, Pitman, NJ 08071, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://pitmanumc.org/wp/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3498194211354467721&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "our-fathers-house-at-pitman-united-methodist-church",
      "poi_latitude": "39.7401766",
      "poi_longitude": "-75.13898019999999",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 856-589-5812",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-0753-779e-8715-bd7fd9766d2e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-0753-779e-8715-bd7fd9766d2e",
        "storage_key": "property/6767906449166928/019d026f-0753-779e-8715-bd7fd9766d2e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJERjkDkTXxokRiV0c2xkVjDA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9a79875b-100f-4fea-896c-95a1ffc6cb93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Rowan University",
      "poi_type": "Education",
      "poi_address": "201 Mullica Hill Rd, Glassboro, NJ 08028, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-2266-74e9-8820-80b437305fdf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-2266-74e9-8820-80b437305fdf",
        "storage_key": "property/6767906449166928/019fcdfd-2266-74e9-8820-80b437305fdf.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.rowan.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5986131075338450699&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rowan-university",
      "poi_latitude": "39.7099689",
      "poi_longitude": "-75.1191932",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 856-256-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-0753-779e-8715-bd7fd9766d2e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-0753-779e-8715-bd7fd9766d2e",
        "storage_key": "property/6767906449166928/019d026f-0753-779e-8715-bd7fd9766d2e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFUBWdKjXxokRC7d5RH8CE1M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c8986772-04ae-46d5-b208-58c5589589f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Gloucester County Institute of Technology",
      "poi_type": "Education",
      "poi_address": "1360 Tanyard Rd, Sewell, NJ 08080, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-2548-729e-9947-1864d10c5489.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-2548-729e-9947-1864d10c5489",
        "storage_key": "property/6767906449166928/019fcdfd-2548-729e-9947-1864d10c5489.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.gcit.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7021933624871249051&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gloucester-county-institute-of-technology",
      "poi_latitude": "39.78854949999999",
      "poi_longitude": "-75.1228857",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 856-468-1445",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-0753-779e-8715-bd7fd9766d2e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-0753-779e-8715-bd7fd9766d2e",
        "storage_key": "property/6767906449166928/019d026f-0753-779e-8715-bd7fd9766d2e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJt1qHKvfQxokRm2TSkm3rcmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f34347cb-c6c2-4977-83a8-03c4cae9ef7d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Broadway Theatre of Pitman",
      "poi_type": "Entertainment",
      "poi_address": "43 S Broadway, Pitman, NJ 08071, USA",
      "poi_short_description": "Renovated 1920s-era venue hosting musical productions, children's theater & concerts.",
      "poi_long_description": "Renovated 1920s-era venue hosting musical productions, children's theater & concerts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-24a4-7109-b4f9-2934b70ae48c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-24a4-7109-b4f9-2934b70ae48c",
        "storage_key": "property/6767906449166928/019fcdfd-24a4-7109-b4f9-2934b70ae48c.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "http://www.thebroadwaytheatre.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11532146951535211540&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "broadway-theatre-of-pitman",
      "poi_latitude": "39.732315",
      "poi_longitude": "-75.130522",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 856-384-8381",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-02a8-704a-9749-59d87b256fe9",
        "storage_key": "property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDdEUSBXXxokRFDTcb41qCqA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_84d28751-d940-4cdf-8a6b-34bc5f6d968d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Pitman Gallery & Art Center",
      "poi_type": "Entertainment",
      "poi_address": "59 S Broadway, Pitman, NJ 08071, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-24be-7067-ab9b-bf43f1e1d6e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-24be-7067-ab9b-bf43f1e1d6e4",
        "storage_key": "property/6767906449166928/019fcdfd-24be-7067-ab9b-bf43f1e1d6e4.webp",
        "width": 1280,
        "height": 856
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1328111477027040513&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pitman-gallery--art-center",
      "poi_latitude": "39.7318957",
      "poi_longitude": "-75.1301618",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 856-553-7757",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-02a8-704a-9749-59d87b256fe9",
        "storage_key": "property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi6pAORXXxokRAe1QClpmbhI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3d67dcc2-a21d-464a-9612-395221f99108",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Pitman Historical Museum",
      "poi_type": "Entertainment",
      "poi_address": "71 Circle Ave, Pitman, NJ 08071, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-2a1a-760b-a1f5-2c183fd02bb5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-2a1a-760b-a1f5-2c183fd02bb5",
        "storage_key": "property/6767906449166928/019fcdfd-2a1a-760b-a1f5-2c183fd02bb5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/PitmanHistoricalMuseum/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4980663262514027066&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pitman-historical-museum",
      "poi_latitude": "39.7304655",
      "poi_longitude": "-75.1320312",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 856-589-1907",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-0b15-771b-b1a7-3b3bb6fdce9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-0b15-771b-b1a7-3b3bb6fdce9f",
        "storage_key": "property/6767906449166928/019d026f-0b15-771b-b1a7-3b3bb6fdce9f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJhYHJOmvXxokROpr8O9neHkU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_dae37f44-65ca-4bb0-b963-3f8439a7dcb8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Music Museum",
      "poi_type": "Entertainment",
      "poi_address": "405 S Broadway, Pitman, NJ 08071, USA",
      "poi_short_description": "Home for guitars, amps and other instruments both new and used.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-2bad-705f-814c-0b697c4f1307.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-2bad-705f-814c-0b697c4f1307",
        "storage_key": "property/6767906449166928/019fcdfd-2bad-705f-814c-0b697c4f1307.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/Music-Museum-111561178884651/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10493863940003318198&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "music-museum",
      "poi_latitude": "39.7284353",
      "poi_longitude": "-75.1267403",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 856-589-4318",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-02a8-704a-9749-59d87b256fe9",
        "storage_key": "property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWdI2cxTXxokRtsktkaexoZE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d4b41985-08e2-45f9-b5a7-c7cbfde34a27",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Pitman Grove Auditorium",
      "poi_type": "Entertainment",
      "poi_address": "160 Circle Ave, Pitman, NJ 08071, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-2b73-74fe-82bf-e086c648fc39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-2b73-74fe-82bf-e086c648fc39",
        "storage_key": "property/6767906449166928/019fcdfd-2b73-74fe-82bf-e086c648fc39.webp",
        "width": 598,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2195969879105539120&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pitman-grove-auditorium",
      "poi_latitude": "39.730683",
      "poi_longitude": "-75.13170699999999",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-02a8-704a-9749-59d87b256fe9",
        "storage_key": "property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGVqqZE3XxokRMAyLZfimeR4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b562813d-7867-401d-9c8f-c7604471b4b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "AMC Deptford 8",
      "poi_type": "Entertainment",
      "poi_address": "1740 Clements Bridge Rd, Deptford, NJ 08096, USA",
      "poi_short_description": "Recliners in the clean theaters at this multiplex showing the latest flicks on large screens.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-2c6f-77a9-9be5-7836d378487d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-2c6f-77a9-9be5-7836d378487d",
        "storage_key": "property/6767906449166928/019fcdfd-2c6f-77a9-9be5-7836d378487d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/philadelphia/amc-deptford-8?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=17961777455117742445&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-deptford-8",
      "poi_latitude": "39.834941",
      "poi_longitude": "-75.1007769",
      "poi_miles_from_property": "8.6 mi",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 856-848-3507",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-0b4f-7672-b1ee-4ae8a87f249e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-0b4f-7672-b1ee-4ae8a87f249e",
        "storage_key": "property/6767906449166928/019d026f-0b4f-7672-b1ee-4ae8a87f249e.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJa7XrMynOxokRbbHpCm4NRfk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_90a1788e-a4ea-4d82-883e-5357f443b603",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Round1 Bowling & Arcade Deptford Mall",
      "poi_type": "Entertainment",
      "poi_address": "1750 Deptford Center Rd Ste 2350, Deptford, NJ 08096, USA",
      "poi_short_description": "Family-friendly entertainment center at Deptford Mall with bowling, arcade games, billiards, karaoke, and a bar.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-320a-74df-8aeb-b8ef3bc0b0fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-320a-74df-8aeb-b8ef3bc0b0fe",
        "storage_key": "property/6767906449166928/019fcdfd-320a-74df-8aeb-b8ef3bc0b0fe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.round1usa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15348531487299995424&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "round1-bowling--arcade-deptford-mall",
      "poi_latitude": "39.8302389",
      "poi_longitude": "-75.0978076",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 856-879-9070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-02a8-704a-9749-59d87b256fe9",
        "storage_key": "property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTZbBeqjPxokRIAdqVBHwANU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5327205f-f8d4-4773-8eae-423dd3e6a763",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Bowlero Turnersville",
      "poi_type": "Entertainment",
      "poi_address": "100 American Blvd, Blackwood, NJ 08012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-32a0-741f-bf67-de43eb327046.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-32a0-741f-bf67-de43eb327046",
        "storage_key": "property/6767906449166928/019fcdfd-32a0-741f-bf67-de43eb327046.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bowlero.com/location/bowlero-turnersville/?utm_source=gbp&utm_medium=organic&utm_campaign=yext_listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=1291942168215656749&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bowlero-turnersville",
      "poi_latitude": "39.7239748",
      "poi_longitude": "-75.03365819999999",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 856-629-2422",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-02a8-704a-9749-59d87b256fe9",
        "storage_key": "property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFYBjyGvUxokRLZnXlo7m7RE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2b336e5c-a04c-4200-8fd5-e118914a1f89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Adventure Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "1 Riverside Dr, Camden, NJ 08103, USA",
      "poi_short_description": "Massive aquarium with a 3D theater, plus hippos, stingrays & an underwater shark tunnel.",
      "poi_long_description": "Massive aquarium with a 3D theater, plus hippos, stingrays & an underwater shark tunnel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-32f6-77ee-ba08-e79b43408b10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-32f6-77ee-ba08-e79b43408b10",
        "storage_key": "property/6767906449166928/019fcdfd-32f6-77ee-ba08-e79b43408b10.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.adventureaquarium.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2298813021411118508&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adventure-aquarium",
      "poi_latitude": "39.9460868",
      "poi_longitude": "-75.1311712",
      "poi_miles_from_property": "16.4 mi",
      "poi_walking_minutes": "6 hours 2 mins",
      "poi_biking_minutes": "1 hour 24 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 844-474-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-02a8-704a-9749-59d87b256fe9",
        "storage_key": "property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBU1gv_LIxokRrI1AakMG5x8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d79c86a2-cd88-40a6-bdfc-59514d93d4be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "BB-62 Battleship New Jersey",
      "poi_type": "Entertainment",
      "poi_address": "100 Clinton St, Camden, NJ 08103, USA",
      "poi_short_description": "Visitors can tour the decommissioned battleship's 887-ft.-long deck & sailors’ living quarters.",
      "poi_long_description": "Visitors can tour the decommissioned battleship's 887-ft.-long deck & sailors’ living quarters.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-3319-7677-bd2b-5e65bf9d02af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-3319-7677-bd2b-5e65bf9d02af",
        "storage_key": "property/6767906449166928/019fcdfd-3319-7677-bd2b-5e65bf9d02af.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.battleshipnewjersey.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11001799642450627255&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bb-62-battleship-new-jersey",
      "poi_latitude": "39.9394484",
      "poi_longitude": "-75.1330734",
      "poi_miles_from_property": "16.7 mi",
      "poi_walking_minutes": "6 hours 7 mins",
      "poi_biking_minutes": "1 hour 25 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 856-966-1652",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-0b15-771b-b1a7-3b3bb6fdce9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-0b15-771b-b1a7-3b3bb6fdce9f",
        "storage_key": "property/6767906449166928/019d026f-0b15-771b-b1a7-3b3bb6fdce9f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJaxvwROrIxokRtwpKGnw-rpg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bf8a2882-79a5-4667-8872-67fb2a11463d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Jefferson Stratford Hospital",
      "poi_type": "Health",
      "poi_address": "18 Laurel Rd East, Stratford, NJ 08084, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-38c8-7514-b185-8b5b8638e1ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-38c8-7514-b185-8b5b8638e1ec",
        "storage_key": "property/6767906449166928/019fcdfd-38c8-7514-b185-8b5b8638e1ec.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.jeffersonhealth.org/locations/stratford-hospital?utm_source=google&utm_medium=organic&utm_campaign=gbp-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=17042968694022426207&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jefferson-stratford-hospital",
      "poi_latitude": "39.8281678",
      "poi_longitude": "-75.00826599999999",
      "poi_miles_from_property": "11.1 mi",
      "poi_walking_minutes": "4 hours 5 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 856-346-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-0b63-7117-b9b4-c3410be75487.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-0b63-7117-b9b4-c3410be75487",
        "storage_key": "property/6767906449166928/019d026f-0b63-7117-b9b4-c3410be75487.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZfXwCXrNxokRX05PzbrJhOw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cdf2bd7f-a576-4f91-9485-69e5e9d1f2e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Jefferson Stratford Hospital",
      "poi_type": "Health",
      "poi_address": "18 Laurel Rd East, Stratford, NJ 08084, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-38c8-7514-b185-8b5b8638e1ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-38c8-7514-b185-8b5b8638e1ec",
        "storage_key": "property/6767906449166928/019fcdfd-38c8-7514-b185-8b5b8638e1ec.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.jeffersonhealth.org/locations/stratford-hospital?utm_source=google&utm_medium=organic&utm_campaign=gbp-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=17042968694022426207&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jefferson-stratford-hospital",
      "poi_latitude": "39.8281678",
      "poi_longitude": "-75.00826599999999",
      "poi_miles_from_property": "11.1 mi",
      "poi_walking_minutes": "4 hours 5 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 856-346-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-0b63-7117-b9b4-c3410be75487.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-0b63-7117-b9b4-c3410be75487",
        "storage_key": "property/6767906449166928/019d026f-0b63-7117-b9b4-c3410be75487.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZfXwCXrNxokRX05PzbrJhOw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_04cf7ca9-e89a-4f9b-95b3-e0f2d723210d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Pitman Pharmacy",
      "poi_type": "Health",
      "poi_address": "39 S Broadway, Pitman, NJ 08071, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-0aad-76ba-9aa0-0644abb0672c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-0aad-76ba-9aa0-0644abb0672c",
        "storage_key": "property/6767906449166928/019fcdfd-0aad-76ba-9aa0-0644abb0672c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.pitmanpharmacy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8631502652286465318&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pitman-pharmacy",
      "poi_latitude": "39.732417",
      "poi_longitude": "-75.1305436",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 856-589-2392",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-02aa-73fb-9f52-8f48727e1ac8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-02aa-73fb-9f52-8f48727e1ac8",
        "storage_key": "property/6767906449166928/019d026f-02aa-73fb-9f52-8f48727e1ac8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh_lVSBXXxokRJnVgO-5ByXc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_dfa6a0ac-54cc-483d-8a0b-14b59410bbc9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health",
      "poi_address": "675 Woodbury Glassboro Rd, Sewell, NJ 08080, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-395e-75bc-87b0-0d94a2da09d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-395e-75bc-87b0-0d94a2da09d7",
        "storage_key": "property/6767906449166928/019fcdfd-395e-75bc-87b0-0d94a2da09d7.webp",
        "width": 1248,
        "height": 1280
      },
      "poi_business_url": "https://www.cvs.com/store-locator/sewell-nj-pharmacies/675-woodbury-glassboro-rd-sewell-nj-08080/storeid=17447?WT.mc_id=LS_GOOGLE_RX_17447",
      "poi_directions_map_url": "https://maps.google.com/?cid=17161889419140281619&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "39.76458780000001",
      "poi_longitude": "-75.1313698",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 856-415-2381",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-02aa-73fb-9f52-8f48727e1ac8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-02aa-73fb-9f52-8f48727e1ac8",
        "storage_key": "property/6767906449166928/019d026f-02aa-73fb-9f52-8f48727e1ac8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS-Ml077QxokREzVkxn9HK-4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d61b6370-cae0-4282-b9bf-cf177a4fbda4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health",
      "poi_address": "221 Delsea Dr N, Glassboro, NJ 08028, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-39ae-7284-bc00-b8709357aae8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-39ae-7284-bc00-b8709357aae8",
        "storage_key": "property/6767906449166928/019fcdfd-39ae-7284-bc00-b8709357aae8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-221+delsea+dr+n-glassboro-nj-08028/id=12048",
      "poi_directions_map_url": "https://maps.google.com/?cid=14765483806429367417&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "39.7074838",
      "poi_longitude": "-75.1094162",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 856-881-5945",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-02a8-704a-9749-59d87b256fe9",
        "storage_key": "property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-VrhPqvXxokReUwBg0qJ6cw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d29f5add-0608-4eaf-8840-c9a0c5b1d9c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Pulse Fitness Professionals",
      "poi_type": "Health",
      "poi_address": "700 Delsea Dr, Pitman, NJ 08071, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=579618747825245610&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pulse-fitness-professionals",
      "poi_latitude": "39.7396393",
      "poi_longitude": "-75.1128451",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 856-217-7393",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-02a8-704a-9749-59d87b256fe9",
        "storage_key": "property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_TsgdybXxokRqs1HIS44Cwg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0dfa6afa-544c-4e33-bc87-069b965f7f5d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health",
      "poi_address": "731 Delsea Dr N, Glassboro, NJ 08028, USA",
      "poi_short_description": "Health club chain with cardio equipment, swimming pools, basketball courts and strength machines.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-3a56-70ba-9624-702d959d1711.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-3a56-70ba-9624-702d959d1711",
        "storage_key": "property/6767906449166928/019fcdfd-3a56-70ba-9624-702d959d1711.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=1098&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=17264881001488401735&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "39.7206222",
      "poi_longitude": "-75.11636890000001",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 856-556-1071",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-02a8-704a-9749-59d87b256fe9",
        "storage_key": "property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYQ03JwXXxokRR0UbL8wtme8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_50f913a0-dcba-42cf-9baa-9b489443fba8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Four Seasons Fitness",
      "poi_type": "Health",
      "poi_address": "626 Delsea Dr, Glassboro, NJ 08028, USA",
      "poi_short_description": "Longtime fitness center with cardio machines, weights, and group classes, plus a sauna.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-3f63-7701-b316-e5707e0e6bd1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-3f63-7701-b316-e5707e0e6bd1",
        "storage_key": "property/6767906449166928/019fcdfd-3f63-7701-b316-e5707e0e6bd1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.hugeclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12017050913079933210&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "four-seasons-fitness",
      "poi_latitude": "39.7173183",
      "poi_longitude": "-75.1110333",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 856-881-9418",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-02a8-704a-9749-59d87b256fe9",
        "storage_key": "property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCWQpuAPXxokRGrnp6SIkxaY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0efbb5e1-6dc2-439b-9306-dc12b0f8af2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Dharma Yoga",
      "poi_type": "Health",
      "poi_address": "30 Pitman Ave, Pitman, NJ 08071, USA",
      "poi_short_description": "Yoga studio offering classes, workshops, and massages.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-3fdd-70a8-ba58-a110440f4539.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-3fdd-70a8-ba58-a110440f4539",
        "storage_key": "property/6767906449166928/019fcdfd-3fdd-70a8-ba58-a110440f4539.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.dharmawellnessstudio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11856600311688598300&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dharma-yoga",
      "poi_latitude": "39.7320165",
      "poi_longitude": "-75.12927970000001",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 856-981-7750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-0753-779e-8715-bd7fd9766d2e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-0753-779e-8715-bd7fd9766d2e",
        "storage_key": "property/6767906449166928/019d026f-0753-779e-8715-bd7fd9766d2e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXcwIScrZxokRHBP8HSobi6Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_dcd2b932-eea2-41d7-a1ac-c5f65db626aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "JAG Physical Therapy",
      "poi_type": "Health",
      "poi_address": "8 N Broadway Ste 1, Pitman, NJ 08071, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-4076-743f-97ca-5088904b784e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-4076-743f-97ca-5088904b784e",
        "storage_key": "property/6767906449166928/019fcdfd-4076-743f-97ca-5088904b784e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.jagpt.com/physical-therapy-clinics/nj/gloucester/pitman/?utm_campaign=gmb-listing&utm_medium=organic&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=3710189687601613719&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jag-physical-therapy",
      "poi_latitude": "39.7334071",
      "poi_longitude": "-75.13213069999999",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 856-214-2827",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-02a8-704a-9749-59d87b256fe9",
        "storage_key": "property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpwCnpmrXxokRl8vPCt09fTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_913cec0e-c28d-4d04-886c-69768bf9468a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Peter Lumber Co",
      "poi_type": "Outdoor",
      "poi_address": "600 W Holly Ave, Pitman, NJ 08071, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-4122-7334-a87d-a1f150c098ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-4122-7334-a87d-a1f150c098ae",
        "storage_key": "property/6767906449166928/019fcdfd-4122-7334-a87d-a1f150c098ae.webp",
        "width": 1280,
        "height": 809
      },
      "poi_business_url": "http://www.peterlumber.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16261752976372976221&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peter-lumber-co",
      "poi_latitude": "39.7325457",
      "poi_longitude": "-75.1420878",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 856-589-2362",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-0751-7277-b31b-fd884d385c72.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-0751-7277-b31b-fd884d385c72",
        "storage_key": "property/6767906449166928/019d026f-0751-7277-b31b-fd884d385c72.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ7Vd8fWjXxokRXcrcbSxareE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d8b628db-e814-4ca9-92fd-a327da11935c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Alcyon Lake",
      "poi_type": "Outdoor",
      "poi_address": "W Holly Ave, Pitman, NJ 08071, USA",
      "poi_short_description": "Picnic, soccer-, baseball- and softball-friendly, family-oriented park, offering a disc golf course, soccer fields, a playground, clean restrooms, a lakeside boat launch, and an extensive network of trails.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-4707-737a-b903-2ce1d7d03d56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-4707-737a-b903-2ce1d7d03d56",
        "storage_key": "property/6767906449166928/019fcdfd-4707-737a-b903-2ce1d7d03d56.webp",
        "width": 1050,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14505496682413448529&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alcyon-lake",
      "poi_latitude": "39.729737",
      "poi_longitude": "-75.1448838",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-0ed5-723c-a7fc-6f04ac07d940.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-0ed5-723c-a7fc-6f04ac07d940",
        "storage_key": "property/6767906449166928/019d026f-0ed5-723c-a7fc-6f04ac07d940.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJk-sp4K_XxokRUV3cFWHgTck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8df27b2e-153b-47e8-9892-37ee1067f34e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Alcyon Lake",
      "poi_type": "Outdoor",
      "poi_address": "W Holly Ave, Pitman, NJ 08071, USA",
      "poi_short_description": "Picnic, soccer-, baseball- and softball-friendly, family-oriented park, offering a disc golf course, soccer fields, a playground, clean restrooms, a lakeside boat launch, and an extensive network of trails.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-4707-737a-b903-2ce1d7d03d56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-4707-737a-b903-2ce1d7d03d56",
        "storage_key": "property/6767906449166928/019fcdfd-4707-737a-b903-2ce1d7d03d56.webp",
        "width": 1050,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14505496682413448529&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alcyon-lake",
      "poi_latitude": "39.729737",
      "poi_longitude": "-75.1448838",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-0ed5-723c-a7fc-6f04ac07d940.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-0ed5-723c-a7fc-6f04ac07d940",
        "storage_key": "property/6767906449166928/019d026f-0ed5-723c-a7fc-6f04ac07d940.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJk-sp4K_XxokRUV3cFWHgTck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b81cb443-a2a5-47de-969a-cb500bfc4250",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Ballard Park",
      "poi_type": "Outdoor",
      "poi_address": "15 Pitman Ave, Pitman, NJ 08071, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-46fa-74ea-a491-9f4a39d3d727.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-46fa-74ea-a491-9f4a39d3d727",
        "storage_key": "property/6767906449166928/019fcdfd-46fa-74ea-a491-9f4a39d3d727.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12533207200914084243&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ballard-park",
      "poi_latitude": "39.73133079999999",
      "poi_longitude": "-75.1294542",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-0ed5-723c-a7fc-6f04ac07d940.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-0ed5-723c-a7fc-6f04ac07d940",
        "storage_key": "property/6767906449166928/019d026f-0ed5-723c-a7fc-6f04ac07d940.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__-_GRXXxokRkxHaoovl7q0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3b89d1b4-8f35-440c-a53a-e6d0663d47c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Broadway Theatre of Pitman",
      "poi_type": "Outdoor",
      "poi_address": "43 S Broadway, Pitman, NJ 08071, USA",
      "poi_short_description": "Renovated 1920s-era venue hosting musical productions, children's theater & concerts.",
      "poi_long_description": "Renovated 1920s-era venue hosting musical productions, children's theater & concerts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-24a4-7109-b4f9-2934b70ae48c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-24a4-7109-b4f9-2934b70ae48c",
        "storage_key": "property/6767906449166928/019fcdfd-24a4-7109-b4f9-2934b70ae48c.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "http://www.thebroadwaytheatre.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11532146951535211540&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "broadway-theatre-of-pitman",
      "poi_latitude": "39.732315",
      "poi_longitude": "-75.130522",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 856-384-8381",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-02a8-704a-9749-59d87b256fe9",
        "storage_key": "property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDdEUSBXXxokRFDTcb41qCqA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_48396988-ede4-41af-b1bb-f3ba130816d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Shertel Park NJ",
      "poi_type": "Outdoor",
      "poi_address": "&, Lincoln Ave & Laurel Ave, Pitman, NJ 08071, USA",
      "poi_short_description": "Relaxed park with a playground, plus basketball and tennis courts for casual play.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-47ab-70e3-b00c-938db337f5d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-47ab-70e3-b00c-938db337f5d1",
        "storage_key": "property/6767906449166928/019fcdfd-47ab-70e3-b00c-938db337f5d1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.pitman.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12947251169187698360&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shertel-park-nj",
      "poi_latitude": "39.7282999",
      "poi_longitude": "-75.1326892",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-0ed5-723c-a7fc-6f04ac07d940.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-0ed5-723c-a7fc-6f04ac07d940",
        "storage_key": "property/6767906449166928/019d026f-0ed5-723c-a7fc-6f04ac07d940.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJtb2PlWzXxokRuJYxRVfgrbM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e17a32fd-173d-4dfd-a8a5-f073d22cc189",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Pitman Grove Auditorium",
      "poi_type": "Outdoor",
      "poi_address": "160 Circle Ave, Pitman, NJ 08071, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-2b73-74fe-82bf-e086c648fc39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-2b73-74fe-82bf-e086c648fc39",
        "storage_key": "property/6767906449166928/019fcdfd-2b73-74fe-82bf-e086c648fc39.webp",
        "width": 598,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2195969879105539120&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pitman-grove-auditorium",
      "poi_latitude": "39.730683",
      "poi_longitude": "-75.13170699999999",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-02a8-704a-9749-59d87b256fe9",
        "storage_key": "property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGVqqZE3XxokRMAyLZfimeR4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_01bbced4-c26d-4c3c-9d69-aeb7cf24d9f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Betty Park",
      "poi_type": "Outdoor",
      "poi_address": "6 Cedar Ave, Pitman, NJ 08071, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1467757218836525573&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "betty-park",
      "poi_latitude": "39.730801",
      "poi_longitude": "-75.14049159999999",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-0ed5-723c-a7fc-6f04ac07d940.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-0ed5-723c-a7fc-6f04ac07d940",
        "storage_key": "property/6767906449166928/019d026f-0ed5-723c-a7fc-6f04ac07d940.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQAA3WjXxokRBTJE_WmFXhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f95a67c0-f225-44dc-94bd-2f4bf6ec94ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Glen Lake Boulevard",
      "poi_type": "Outdoor",
      "poi_address": "Glen Lake Blvd, Pitman, NJ 08071, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?q=Glen+Lake+Blvd,+Pitman,+NJ+08071,+USA&ftid=0x89c6d70e6a9ea261:0xecc2b71a5551eaa9&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glen-lake-boulevard",
      "poi_latitude": "39.7237561",
      "poi_longitude": "-75.1259352",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-02a8-704a-9749-59d87b256fe9",
        "storage_key": "property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "EiVHbGVuIExha2UgQmx2ZCwgUGl0bWFuLCBOSiAwODA3MSwgVVNBIi4qLAoUChIJYaKeag7XxokRqepRVRq3wuwSFAoSCRmcjlQV18aJERkU9iJGYmKB",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2096b2ac-edda-4237-b285-618486587fc3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Edelman Fossil Park & Museum of Rowan University",
      "poi_type": "Outdoor",
      "poi_address": "66 Million Mosasaur Wy, Sewell, NJ 08080, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-4832-76ca-9aa3-1d0bdfc2ded3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-4832-76ca-9aa3-1d0bdfc2ded3",
        "storage_key": "property/6767906449166928/019fcdfd-4832-76ca-9aa3-1d0bdfc2ded3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.efm.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16770405675237727794&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "edelman-fossil-park--museum-of-rowan-university",
      "poi_latitude": "39.761987",
      "poi_longitude": "-75.1284431",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 856-284-3466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-0b15-771b-b1a7-3b3bb6fdce9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-0b15-771b-b1a7-3b3bb6fdce9f",
        "storage_key": "property/6767906449166928/019d026f-0b15-771b-b1a7-3b3bb6fdce9f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJCVgLksjQxokRMl69sxtzvOg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_abda2e86-ba21-473b-a016-7656904333da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Inspira Health Center Woodbury",
      "poi_type": "Offices",
      "poi_address": "509 N Broad St, Woodbury, NJ 08096, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-4ef2-77fc-a21f-0fa87adf6262.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-4ef2-77fc-a21f-0fa87adf6262",
        "storage_key": "property/6767906449166928/019fcdfd-4ef2-77fc-a21f-0fa87adf6262.webp",
        "width": 1280,
        "height": 736
      },
      "poi_business_url": "https://www.inspirahealthnetwork.org/locations/inspira-health-center-woodbury",
      "poi_directions_map_url": "https://maps.google.com/?cid=2170008355021517448&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "inspira-health-center-woodbury",
      "poi_latitude": "39.8435878",
      "poi_longitude": "-75.15082509999999",
      "poi_miles_from_property": "9.0 mi",
      "poi_walking_minutes": "3 hours 17 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 856-845-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-0b63-7117-b9b4-c3410be75487.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-0b63-7117-b9b4-c3410be75487",
        "storage_key": "property/6767906449166928/019d026f-0b63-7117-b9b4-c3410be75487.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJPcNKC_nPxokRiPKvCBprHR4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_313c079c-086a-451b-86d5-86a3472c8eaa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Rowan University",
      "poi_type": "Offices",
      "poi_address": "201 Mullica Hill Rd, Glassboro, NJ 08028, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-2266-74e9-8820-80b437305fdf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-2266-74e9-8820-80b437305fdf",
        "storage_key": "property/6767906449166928/019fcdfd-2266-74e9-8820-80b437305fdf.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.rowan.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5986131075338450699&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rowan-university",
      "poi_latitude": "39.7099689",
      "poi_longitude": "-75.1191932",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 856-256-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-0753-779e-8715-bd7fd9766d2e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-0753-779e-8715-bd7fd9766d2e",
        "storage_key": "property/6767906449166928/019d026f-0753-779e-8715-bd7fd9766d2e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFUBWdKjXxokRC7d5RH8CE1M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a2f6f13c-f4d0-49b8-8bac-9db0274719cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "2 S Broad St",
      "poi_type": "Offices",
      "poi_address": "2 S Broad St, Woodbury, NJ 08096, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15801778586120385059&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "2-s-broad-st",
      "poi_latitude": "39.8378633",
      "poi_longitude": "-75.1527595",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-02a8-704a-9749-59d87b256fe9",
        "storage_key": "property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBYlHHgDQxokRI3IUFecxS9s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2426bd68-9670-494f-a61d-084511699fae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Rowan College of South Jersey",
      "poi_type": "Offices",
      "poi_address": "1400 Tanyard Rd, Sewell, NJ 08080, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-4d80-74fa-b9aa-af2ffc5e25b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-4d80-74fa-b9aa-af2ffc5e25b6",
        "storage_key": "property/6767906449166928/019fcdfd-4d80-74fa-b9aa-af2ffc5e25b6.webp",
        "width": 1024,
        "height": 682
      },
      "poi_business_url": "https://www.rcsj.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14475758077881017340&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rowan-college-of-south-jersey",
      "poi_latitude": "39.7805687",
      "poi_longitude": "-75.12261889999999",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 856-468-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-0753-779e-8715-bd7fd9766d2e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-0753-779e-8715-bd7fd9766d2e",
        "storage_key": "property/6767906449166928/019d026f-0753-779e-8715-bd7fd9766d2e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJl8TFvO_QxokR_OOWpkY55Mg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4c9f2d97-c7de-4620-8242-85080db15991",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Pureland Industrial Complex",
      "poi_type": "Offices",
      "poi_address": "545 Beckett Rd Suite 204, Logan Township, NJ 08085, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://pureland.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15399854224508890418&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pureland-industrial-complex",
      "poi_latitude": "39.7605431",
      "poi_longitude": "-75.3541077",
      "poi_miles_from_property": "13.1 mi",
      "poi_walking_minutes": "4 hours 46 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 856-467-2333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-02a8-704a-9749-59d87b256fe9",
        "storage_key": "property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZQPX77_gxokRMq2mRNNFt9U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1e984d35-9dac-44d7-8eea-f3a5fc216541",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "ACY5 Amazon Fulfillment Center",
      "poi_type": "Offices",
      "poi_address": "2277 Center Square Rd, Logan Township, NJ 08085, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-4e18-7271-80bf-4ed710218551.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-4e18-7271-80bf-4ed710218551",
        "storage_key": "property/6767906449166928/019fcdfd-4e18-7271-80bf-4ed710218551.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.amazon.jobs/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4411948117677196412&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "acy5-amazon-fulfillment-center",
      "poi_latitude": "39.7755611",
      "poi_longitude": "-75.377723",
      "poi_miles_from_property": "14.9 mi",
      "poi_walking_minutes": "5 hours 25 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-02a8-704a-9749-59d87b256fe9",
        "storage_key": "property/6767906449166928/019d026f-02a8-704a-9749-59d87b256fe9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC05bddDgxokRfESaAXBjOj0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_57266d3f-4063-41dd-90e5-ad3b9b5e160b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Jefferson Washington Township Hospital",
      "poi_type": "Offices",
      "poi_address": "435 Hurffville - Cross Keys Rd, Sewell, NJ 08080, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-4ecb-71e4-b5f6-2c9292a3226d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-4ecb-71e4-b5f6-2c9292a3226d",
        "storage_key": "property/6767906449166928/019fcdfd-4ecb-71e4-b5f6-2c9292a3226d.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.jeffersonhealth.org/locations/washington-township-hospital?utm_source=google&utm_medium=organic&utm_campaign=gbp-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=14478532242790803844&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jefferson-washington-township-hospital",
      "poi_latitude": "39.73567449999999",
      "poi_longitude": "-75.0658206",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 856-582-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-0b63-7117-b9b4-c3410be75487.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-0b63-7117-b9b4-c3410be75487",
        "storage_key": "property/6767906449166928/019d026f-0b63-7117-b9b4-c3410be75487.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2fcOo6jWxokRhOmVQF0U7sg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a9ae15c5-7d99-4298-b0ed-e149ea54a116",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Rutgers University–Camden",
      "poi_type": "Offices",
      "poi_address": "303 Cooper St, Camden, NJ 08102, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-5827-740f-b058-140c22ed9f60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-5827-740f-b058-140c22ed9f60",
        "storage_key": "property/6767906449166928/019fcdfd-5827-740f-b058-140c22ed9f60.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://www.camden.rutgers.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13922792056188264575&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rutgers-universitycamden",
      "poi_latitude": "39.9484052",
      "poi_longitude": "-75.1217367",
      "poi_miles_from_property": "16.4 mi",
      "poi_walking_minutes": "6 hours 1 min",
      "poi_biking_minutes": "1 hour 39 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 856-225-1766",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-0753-779e-8715-bd7fd9766d2e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-0753-779e-8715-bd7fd9766d2e",
        "storage_key": "property/6767906449166928/019d026f-0753-779e-8715-bd7fd9766d2e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJfX2IGPHIxokRf2C75puxN8E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f5a1beed-828e-424c-9f77-d427e2efd2cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Cooper University Hospital",
      "poi_type": "Offices",
      "poi_address": "1 Cooper Plaza, Camden, NJ 08103, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-5536-7500-b05f-eaa99ff20c53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-5536-7500-b05f-eaa99ff20c53",
        "storage_key": "property/6767906449166928/019fcdfd-5536-7500-b05f-eaa99ff20c53.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.cooperhealth.org/?utm_source=google&utm_medium=organic&utm_campaign=google_my_business",
      "poi_directions_map_url": "https://maps.google.com/?cid=680027330547190836&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cooper-university-hospital",
      "poi_latitude": "39.9416173",
      "poi_longitude": "-75.1171062",
      "poi_miles_from_property": "15.8 mi",
      "poi_walking_minutes": "5 hours 48 mins",
      "poi_biking_minutes": "1 hour 36 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 856-342-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-0b63-7117-b9b4-c3410be75487.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-0b63-7117-b9b4-c3410be75487",
        "storage_key": "property/6767906449166928/019d026f-0b63-7117-b9b4-c3410be75487.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1-ECnOTIxokRNIzSEkHxbwk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_60aca6ca-d8be-4166-aaf0-5e63d00a7adb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "poi_name": "Virtua Voorhees Hospital",
      "poi_type": "Offices",
      "poi_address": "100 Bowman Dr, Voorhees Township, NJ 08043, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-55d1-745f-8ae3-a01f5458eaa5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdfd-55d1-745f-8ae3-a01f5458eaa5",
        "storage_key": "property/6767906449166928/019fcdfd-55d1-745f-8ae3-a01f5458eaa5.webp",
        "width": 1280,
        "height": 1260
      },
      "poi_business_url": "https://www.virtua.org/locations/voorhees-hospital?utm_source=local&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=13922560869268213923&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "virtua-voorhees-hospital",
      "poi_latitude": "39.84165369999999",
      "poi_longitude": "-74.9270074",
      "poi_miles_from_property": "16.8 mi",
      "poi_walking_minutes": "6 hours 11 mins",
      "poi_biking_minutes": "1 hour 32 mins",
      "poi_driving_minutes": "36 mins",
      "poi_business_phone": "+1 856-247-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019d026f-0b63-7117-b9b4-c3410be75487.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-0b63-7117-b9b4-c3410be75487",
        "storage_key": "property/6767906449166928/019d026f-0b63-7117-b9b4-c3410be75487.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJVW1Q0S8zwYkRo1B8gFjfNsE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "custom_91d60eff-0427-49a2-8857-d77febb4d05b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_e5516b7f-512b-4211-84a9-e95096133a2a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_da52788b-516f-42ad-a4ed-424ade27c1d0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_18156144-111e-47ba-a39f-9df03a85b026",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_b5f5e1ba-7958-4bab-908b-2c317a0ebf7c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_d92d5bb5-2f1a-4834-9cd4-63489bb21975",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_fe8c23690f109df6363b2561",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "rating": "5",
      "name": "Chris Player",
      "text": "Just moved in and had an issue with my refrigerator not working. The leasing office was very promt in getting someone out to fix it. Dale, the maintenance man, was very helpful in replacing the entire unit!",
      "date": "2025-07-15",
      "title": "false"
    },
    {
      "id": "ec_dcec65b3b7e0ce1c2348d338",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "rating": "5",
      "name": "Melissa Conklin",
      "text": "I love how quiet and serene my new apartment is. Manager Todd, was great with assisting me during my entire move in journey!",
      "date": "2025-08-12",
      "title": "false"
    },
    {
      "id": "ec_900a191e1d7f3a33e0147d68",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "rating": "5",
      "name": "pipsqueak677",
      "text": "PLEASE, PLEASE, PLEASE renovate the Laundry Room at West. Kinda dirty, old, and musty. Otherwise, a great place to live! Worth the price in my opinion. Maintenance men are polite and quick! Great complex in a great, safe area. Lots of older residents along with young couples. Never had a major issue. Walls are VERY thin so you will hear everything",
      "date": "2024-08-04",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_5b3755b0-b1ff-427c-97ac-2437ce05a70c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fa4c5-c56f-7098-85fe-866cd8fe1176.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fa4c5-c56f-7098-85fe-866cd8fe1176",
        "storage_key": "property/6767906449166928/019fa4c5-c56f-7098-85fe-866cd8fe1176.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": " Holly Court",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=6351a3fce0032e1d3081ad86&sourceId=1001"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_e85ca55ea0ac29b41b3a7d7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "engrain",
      "external_id": "429444",
      "name": "Admin Fee",
      "description": "false",
      "amount": 100,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_49d6fabfb807bdc0c9bc6563",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "engrain",
      "external_id": "429445",
      "name": "Security Deposit",
      "description": "Deposit amount applies with approved credit and may be higher for conditional approvals.",
      "amount": 1000,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": true,
      "is_taxable": false
    },
    {
      "id": "ec_d52482c936663f10f29b0030",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "engrain",
      "external_id": "429446",
      "name": "Pet Fee",
      "description": "One-time fee of $350 covers up to 2 pets.",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_d65b86b9090ccce00dc9ef57",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "engrain",
      "external_id": "429447",
      "name": "Application Fee",
      "description": "Per applicant.",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_8cb1c4c1aa52fc1ab6c39ba1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "engrain",
      "external_id": "429449",
      "name": "Month To Month Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_2bde7bcd0dc474758f61e8b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "engrain",
      "external_id": "429450",
      "name": "Pet Rent",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "50.00 / 25.00",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_d7b49108b8916420bca6eb11",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "engrain",
      "external_id": "429454",
      "name": "Reservation Fee",
      "description": "false",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_b1e68f7dc2bc1b3e12fe7cf8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "engrain",
      "external_id": "429455",
      "name": "Transfer Fee",
      "description": "false",
      "amount": 500,
      "amount_max": 1000,
      "amount_raw": "false",
      "amount_type": "range",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_a5bbf74f679004a364b428b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "engrain",
      "external_id": "489293",
      "name": "Amenity Fee",
      "description": "false",
      "amount": 250,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "community",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_d642171a40561633d3f8ab14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "engrain",
      "external_id": "536743",
      "name": "Utility - New Account Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_12887c0288eb9093515afd0a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "engrain",
      "external_id": "536745",
      "name": "Utility - Administrative Billing Fee",
      "description": "false",
      "amount": 4.66,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_5a4c41ed59060a7f61581947",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "engrain",
      "external_id": "536747",
      "name": "Trash Service",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_45c48db6fa3972e591bf6d6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "engrain",
      "external_id": "543094",
      "name": "Utility - Water/Sewer Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_52170280fd20e5330a331065",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "engrain",
      "external_id": "543100",
      "name": "Utility - Electric Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_da291fe6efcbd1ce9d28cc95",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "engrain",
      "external_id": "543105",
      "name": "Utility - Gas Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_1463acce99ba8d891cc473ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "engrain",
      "external_id": "832507",
      "name": "Buy-Out Fee",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "One Month's Rent",
      "amount_type": "text",
      "timing": "One-time",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_5dd5b2f71cb4bc8e35f4e6a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "engrain",
      "external_id": "832509",
      "name": "Late Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per occurrence",
      "category": "penalties",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_eaa0e62df0402da0f5b837ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "engrain",
      "external_id": "832510",
      "name": "Lockout Fee - After Hours",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_f07d28dbf7d5ec09cf33a68d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "engrain",
      "external_id": "832515",
      "name": "NSF/Returned Check Fee",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_79b82f93c65fde299c302804",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "engrain",
      "external_id": "832521",
      "name": "Yearly Pool Fee",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Annually",
      "category": "community",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_73b3b5bdac173836e559d502",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "engrain",
      "external_id": "832527",
      "name": "Certificate of Occupancy Fee",
      "description": "false",
      "amount": 75,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a9766-a8b8-7683-84dc-3bfb63f8ec89",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "aion-holly-court",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928"
    },
    {
      "lead_collector_id": "019c3043-c3e5-70cf-b761-f60977f9919f",
      "lead_source": "FACEBOOK_ADS",
      "name": "holly-court",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928"
    },
    {
      "lead_collector_id": "019c3043-c456-751d-83fc-bb1c1a5950ce",
      "lead_source": "LANDING_PAGE",
      "name": "holly-court",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "page_item_url": "in-unit-laundry-apartments-pitman-nj-holly-court-949",
      "search_query": "in unit laundry apartments Pitman NJ",
      "category": "Amenity",
      "h1_title": "In Unit Laundry Apartments in Pitman NJ",
      "h2_subtitle": "Discover the convenience of in unit laundry apartments in Pitman, NJ. Holly Court offers modern amenities perfect for comfortable living.",
      "page_copy": "Experience the ultimate convenience at Holly Court, where in unit laundry apartments in Pitman, NJ, meet stylish living. Our community offers a variety of floor plans, from studios to two-bedroom units, each designed with your comfort in mind. Enjoy the luxury of having laundry facilities right in your apartment, making daily chores a breeze.\n\nLocated in the heart of Pitman, Holly Court isn't just about in unit laundry facilities. Dive into relaxation with our sparkling pool or maintain your fitness routine at our state-of-the-art gym. With air conditioning, hardwood floors, and even a dog park, there's something for everyone. Come home to comfort at Holly Court.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and umbrellas.",
        "public_id": "01a015d5-a8cb-7309-8ddd-3b51200d4b10",
        "storage_key": "property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
        "width": 1553,
        "height": 874
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In Unit Laundry Apartments in Pitman NJ",
      "seo_description": "Discover in unit laundry apartments in Pitman NJ at Holly Court. Enjoy modern amenities including a pool and fitness center, perfect for stylish living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "page_item_url": "air-conditioned-apartments-gloucester-county-holly-court-293",
      "search_query": "air conditioned apartments Gloucester County",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Gloucester County",
      "h2_subtitle": "Holly Court offers plush air conditioned apartments right in Gloucester County. Experience ultimate comfort in our modern residences.",
      "page_copy": "Nestled in Gloucester County, Holly Court provides residents with air conditioned apartments that promise comfort through New Jersey's varying seasons. Our modern units, available in studio, one, and two-bedroom layouts, are designed to keep you cool and comfortable year-round. With air conditioning included, your home becomes a perfect retreat.\n\nHolly Court's allure doesn’t end with climate control. Our amenities include a refreshing pool, hardwood floors, and a fitness center to help you live your best life. The serene on-site pond and dog park make it a thriving community for relaxation and recreation. Choose Holly Court for premium air conditioned living in the heart of Gloucester County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and umbrellas.",
        "public_id": "01a015d5-a8cb-7309-8ddd-3b51200d4b10",
        "storage_key": "property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
        "width": 1553,
        "height": 874
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in Gloucester County",
      "seo_description": "Find air conditioned apartments in Gloucester County at Holly Court. Enjoy modern amenities and comfort in a fantastic community setting.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "page_item_url": "apartments-with-dishwasher-pitman-nj-holly-court-501",
      "search_query": "apartments with dishwasher Pitman NJ",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwasher in Pitman NJ",
      "h2_subtitle": "Explore Holly Court's apartments with dishwasher in Pitman, NJ. Enjoy the convenience of modern kitchen amenities in every home.",
      "page_copy": "At Holly Court, we understand the importance of a well-equipped kitchen. That's why each of our Pitman, NJ apartments comes with a dishwasher, making cleanup after meals quick and hassle-free. Whether you choose a studio, one-bedroom, or two-bedroom layout, you can enjoy modern conveniences right at home.\n\nBeyond the kitchen, Holly Court provides a range of amenities designed to enhance your lifestyle. Take a dip in the pool, work out in the fitness center, or relax in air-conditioned comfort. With beautiful hardwood floors and serene surroundings, Holly Court combines functionality with style, ensuring that your living experience is second to none.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and umbrellas.",
        "public_id": "01a015d5-a8cb-7309-8ddd-3b51200d4b10",
        "storage_key": "property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
        "width": 1553,
        "height": 874
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwasher in Pitman NJ",
      "seo_description": "Discover apartments with dishwasher in Pitman NJ at Holly Court. Enjoy modern amenities and comfortable living in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "page_item_url": "apartments-with-pool-08071-holly-court-987",
      "search_query": "apartments with pool 08071",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in 08071",
      "h2_subtitle": "Enjoy the luxury of apartments with a pool in the 08071 area. Holly Court offers modern living with a resort-style pool for residents.",
      "page_copy": "Holly Court invites you to experience a vibrant community featuring apartments with a pool in the 08071 area. Our elegantly designed studio, one-bedroom, and two-bedroom options offer the perfect blend of comfort and style, complemented by our sparkling pool where you can unwind and refresh.\n\nSituated in Pitman, NJ, Holly Court goes beyond just a fabulous pool. Dive into a full suite of amenities including a modern fitness center, dog park, and serene pond. With air conditioning and hardwood floors, each apartment is a haven of comfort. Discover the perfect blend of relaxation and recreation at Holly Court.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and umbrellas.",
        "public_id": "01a015d5-a8cb-7309-8ddd-3b51200d4b10",
        "storage_key": "property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
        "width": 1553,
        "height": 874
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in 08071",
      "seo_description": "Find apartments with a pool in 08071 at Holly Court. Enjoy modern living and luxurious amenities in a relaxing community setting.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "page_item_url": "dog-park-apartments-gloucester-county-holly-court-10",
      "search_query": "dog park apartments Gloucester County",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Gloucester County",
      "h2_subtitle": "Holly Court offers fabulous dog park apartments in Gloucester County. Enjoy a pet-friendly community with amenities for you and your pet.",
      "page_copy": "At Holly Court, we celebrate your furry friends by providing dog park apartments in Gloucester County. Our community is designed with your pets in mind, offering a safe and spacious dog park where they can play and socialize. Situated in the heart of Pitman, NJ, Holly Court promises a pet-friendly environment that caters to both you and your pets' needs.\n\nEmbrace a lifestyle enriched with exceptional amenities, including a refreshing pool, fitness center, and air-conditioned interiors. Choose from our stylish studio, one, or two-bedroom layouts, each featuring modern conveniences like a well-equipped kitchen and hardwood floors. Make Holly Court your home and enjoy a vibrant community, perfect for pet lovers.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and umbrellas.",
        "public_id": "01a015d5-a8cb-7309-8ddd-3b51200d4b10",
        "storage_key": "property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
        "width": 1553,
        "height": 874
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Gloucester County",
      "seo_description": "Discover dog park apartments in Gloucester County at Holly Court. Enjoy a pet-friendly community with modern amenities and a dedicated dog park.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "page_item_url": "studio-apartments-pitman-nj-holly-court-516",
      "search_query": "studio apartments pitman nj",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Pitman NJ",
      "h2_subtitle": "Discover stylish studio apartments in Pitman NJ at Holly Court. Experience modern living with top-notch amenities right at your doorstep.",
      "page_copy": "Welcome to Holly Court, where our studio apartments in Pitman, NJ offer the perfect blend of style and convenience. Each studio is thoughtfully designed, featuring modern amenities like air conditioning and hardwood floors, providing a comfortable and elegant living space that you'll love coming home to every day.\n\nBeyond your personal sanctuary, Holly Court provides access to a range of community amenities. Take a swim in our refreshing pool, keep fit in the fully equipped fitness center, or enjoy a leisurely walk around our serene pond. Situated in Gloucester County, Holly Court stands as an ideal community for individuals seeking both peace and a vibrant lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and umbrellas.",
        "public_id": "01a015d5-a8cb-7309-8ddd-3b51200d4b10",
        "storage_key": "property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
        "width": 1553,
        "height": 874
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Pitman NJ",
      "seo_description": "Find stylish studio apartments in Pitman NJ at Holly Court. Enjoy modern amenities and a welcoming community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-gloucester-county-holly-court-154",
      "search_query": "one bedroom apartments in gloucester county",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Gloucester County",
      "h2_subtitle": "Explore charming one bedroom apartments in Gloucester County at Holly Court. Enjoy a blend of comfort and modern amenities in our vibrant community.",
      "page_copy": "Holly Court presents delightful one bedroom apartments in Gloucester County, designed with your comfort in mind. Each apartment features modern amenities, such as air conditioning, hardwood floors, and a well-appointed kitchen including a microwave, ensuring a cozy and convenient living experience.\n\nLocated in the picturesque Pitman, NJ, our community offers a variety of amenities to enhance your lifestyle. Relax by the refreshing pool, stay active in our fitness center, or take advantage of our serene outdoor spaces, including a sundeck and dog park. At Holly Court, the perfect balance of serenity and activity awaits you.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and umbrellas.",
        "public_id": "01a015d5-a8cb-7309-8ddd-3b51200d4b10",
        "storage_key": "property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
        "width": 1553,
        "height": 874
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Gloucester County",
      "seo_description": "Discover one bedroom apartments in Gloucester County at Holly Court with modern amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-near-08071-holly-court-299",
      "search_query": "two bedroom apartments near 08071",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near 08071",
      "h2_subtitle": "Discover spacious two bedroom apartments near 08071 at Holly Court. Experience modern living in a vibrant community with all the comforts you need.",
      "page_copy": "Experience the ideal blend of space and comfort with our two bedroom apartments near 08071 at Holly Court. Each apartment is thoughtfully designed, offering spacious living areas with features like air conditioning and elegant hardwood floors. Modern convenience is key, with amenities such as a fully equipped kitchen boasting a microwave, ensuring you feel right at home.\n\nLocated in the heart of Pitman, NJ, Holly Court offers more than just a place to live. Enjoy community features like a refreshing pool, a state-of-the-art fitness center, and relaxing outdoor spaces, including a serene pond and sundeck. Our two bedroom apartments offer the perfect environment for both leisure and comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and umbrellas.",
        "public_id": "01a015d5-a8cb-7309-8ddd-3b51200d4b10",
        "storage_key": "property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
        "width": 1553,
        "height": 874
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near 08071",
      "seo_description": "Explore two bedroom apartments near 08071 at Holly Court, with spacious layouts and modern amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "page_item_url": "apartments-near-pitman-jr-sr-high-school-holly-court-354",
      "search_query": "apartments near pitman jr sr high school",
      "category": "School",
      "h1_title": "Apartments Near Pitman Jr Sr High School",
      "h2_subtitle": "Explore Holly Court, offering apartments near Pitman Jr Sr High School. Enjoy a convenient location with modern amenities and community features.",
      "page_copy": "At Holly Court, discover the perfect apartment living experience near Pitman Jr Sr High School. Our apartments cater to your needs with a variety of floor plans, including studio, one, and two-bedroom options, each featuring modern conveniences such as air conditioning and hardwood flooring. \n\nLocated in the heart of Pitman, NJ, Holly Court is just a short drive from Pitman Jr Sr High School, making it convenient for families and students alike. Residents enjoy premium amenities, including a refreshing swimming pool, a well-equipped fitness center, and tranquil outdoor spaces. Experience an ideal blend of comfort and community at Holly Court, where your new home awaits.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and umbrellas.",
        "public_id": "01a015d5-a8cb-7309-8ddd-3b51200d4b10",
        "storage_key": "property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
        "width": 1553,
        "height": 874
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Pitman Jr Sr High School",
      "seo_description": "Find Holly Court apartments near Pitman Jr Sr High School. Enjoy modern amenities and a convenient location in Pitman, NJ.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "page_item_url": "rentals-near-pitman-elementary-school-holly-court-92",
      "search_query": "rentals near pitman elementary school nj",
      "category": "School",
      "h1_title": "Rentals Near Pitman Elementary School NJ",
      "h2_subtitle": "Discover our comfortable rentals near Pitman Elementary School, NJ. Holly Court offers modern amenities and a family-friendly community setting.",
      "page_copy": "Holly Court presents rentals near Pitman Elementary School, NJ, ideal for those seeking a convenient living arrangement close to quality education. Choose from a selection of floor plans including studio, one- or two-bedroom apartments, all designed with your comfort in mind and equipped with air conditioning and hardwood floors.\n\nSituated in the vibrant community of Pitman, NJ, Holly Court offers more than just a place to live. Benefit from amenities such as a swimming pool, a fitness center, and lush outdoor spaces perfect for relaxation. With its proximity to Pitman Elementary School, Holly Court is perfect for families who value education and a nurturing community atmosphere.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and umbrellas.",
        "public_id": "01a015d5-a8cb-7309-8ddd-3b51200d4b10",
        "storage_key": "property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
        "width": 1553,
        "height": 874
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Pitman Elementary School NJ",
      "seo_description": "Explore rentals near Pitman Elementary School, NJ at Holly Court. Enjoy modern amenities and a family-friendly environment.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "page_item_url": "apartments-by-memorial-elementary-school-pitman-holly-court-849",
      "search_query": "apartments by memorial elementary school pitman",
      "category": "School",
      "h1_title": "Apartments by Memorial Elementary School Pitman",
      "h2_subtitle": "Holly Court offers convenient and modern apartments by Memorial Elementary School in Pitman. Experience quality living close to education.",
      "page_copy": "For families seeking proximity to education, Holly Court provides excellent apartments by Memorial Elementary School in Pitman. Choose from our range of spacious floor plans, including studios, and one- or two-bedroom units, equipped with contemporary features such as microwaves and air conditioning.\n\nLocated in the charming community of Pitman, NJ, Holly Court ensures residents enjoy a comfortable lifestyle with access to amenities like a refreshing pool and a state-of-the-art fitness center. Our dog-friendly spaces and tranquil pond add to the appeal, making Holly Court an ideal choice for both families and professionals looking for quality and convenience near Memorial Elementary School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and umbrellas.",
        "public_id": "01a015d5-a8cb-7309-8ddd-3b51200d4b10",
        "storage_key": "property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
        "width": 1553,
        "height": 874
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Memorial Elementary School Pitman",
      "seo_description": "Find Holly Court apartments by Memorial Elementary School Pitman. Enjoy modern living with easy access to school and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "page_item_url": "apartments-near-rowan-university-gloucester-county-holly-court-790",
      "search_query": "apartments near rowan university gloucester county",
      "category": "School",
      "h1_title": "Apartments Near Rowan University Gloucester",
      "h2_subtitle": "Discover stylish apartments near Rowan University in Gloucester County. Holly Court offers modern living in a convenient location.",
      "page_copy": "Holly Court offers stylish and modern apartment living near Rowan University in Gloucester County, making it an excellent choice for students and faculty alike. Choose from a variety of floor plans, including studios, and one- or two-bedroom units, each designed with amenities like hardwood floors and air conditioning.\n\nSituated in the heart of Pitman, NJ, Holly Court is just a quick commute from Rowan University. Enjoy the benefits of a vibrant community with access to amenities such as a swimming pool, fitness center, and a scenic pond area. Whether you're hitting the books or taking a break, Holly Court provides the perfect balance of comfort and convenience for anyone associated with Rowan University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and umbrellas.",
        "public_id": "01a015d5-a8cb-7309-8ddd-3b51200d4b10",
        "storage_key": "property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
        "width": 1553,
        "height": 874
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Rowan University Gloucester",
      "seo_description": "Find Holly Court apartments near Rowan University Gloucester County. Enjoy modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "page_item_url": "holly-court-rentals-gloucester-county-institute-technology-409",
      "search_query": "holly court rentals near gloucester county institute of technology",
      "category": "School",
      "h1_title": "Holly Court Rentals Near GCIT",
      "h2_subtitle": "Explore Holly Court rentals near GCIT for a convenient and comfortable living experience. Enjoy being close to Gloucester County Institute of Technology.",
      "page_copy": "Discover a prime living location with Holly Court rentals near Gloucester County Institute of Technology (GCIT). Our community offers a selection of studio, one-, and two-bedroom apartments, featuring modern amenities like hardwood floors and microwaves to enhance your living experience.\n\nLocated in Pitman, NJ, Holly Court provides easy access to GCIT and the surrounding areas in Gloucester County. Residents enjoy a host of community amenities, including a pool, fitness center, and dog park, perfect for unwinding after a day of work or study. Embrace convenience and style at Holly Court, ideal for students, faculty, and professionals near GCIT.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and umbrellas.",
        "public_id": "01a015d5-a8cb-7309-8ddd-3b51200d4b10",
        "storage_key": "property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
        "width": 1553,
        "height": 874
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Holly Court Rentals Near GCIT",
      "seo_description": "Discover Holly Court rentals near GCIT in Gloucester County. Enjoy modern living close to education and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "page_item_url": "apartments-near-jefferson-stratford-hospital-holly-court-628",
      "search_query": "apartments near Jefferson Stratford Hospital Pitman",
      "category": "Hospital",
      "h1_title": "Apartments Near Jefferson Stratford Hospital",
      "h2_subtitle": "Holly Court offers comfortable apartments near Jefferson Stratford Hospital in Pitman. Discover convenience and modern amenities.",
      "page_copy": "Located conveniently near Jefferson Stratford Hospital, Holly Court provides an ideal living solution for healthcare professionals and hospital visitors in Pitman. Our community features a selection of stylish studio, one-, and two-bedroom apartments equipped with modern amenities such as microwaves and air conditioning.\n\nResidents at Holly Court can enjoy a refreshing pool, a well-equipped fitness center, and easy access to the calm of our scenic pond and sundeck. With its prime location in Pitman, NJ and proximity to Jefferson Stratford Hospital, Holly Court combines comfort and accessibility, making it an excellent choice for those seeking quality apartment living near this key medical facility.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and umbrellas.",
        "public_id": "01a015d5-a8cb-7309-8ddd-3b51200d4b10",
        "storage_key": "property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
        "width": 1553,
        "height": 874
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Jefferson Stratford Hospital",
      "seo_description": "Find Holly Court apartments near Jefferson Stratford Hospital in Pitman. Enjoy modern living with accessibility and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "page_item_url": "housing-close-jefferson-stratford-hospital-gloucester-county-354",
      "search_query": "housing close to Jefferson Stratford Hospital Gloucester County",
      "category": "Hospital",
      "h1_title": "Housing Close to Jefferson Stratford Hospital",
      "h2_subtitle": "Find convenient housing close to Jefferson Stratford Hospital in Gloucester County. Holly Court offers modern amenities and a prime location.",
      "page_copy": "Holly Court in Pitman, NJ provides an excellent housing option near Jefferson Stratford Hospital, located within Gloucester County. Our community offers a range of studio, one-, and two-bedroom apartments, each thoughtfully equipped with modern touches such as hardwood floors and air conditioning.\n\nWith its desirable location, Holly Court places residents near essential healthcare services while still enjoying the tranquility of a premium residential community. The property boasts amenities like a refreshing pool, a fitness center, and a serene pond, making it a perfect blend of accessibility and comfort for anyone seeking housing close to Jefferson Stratford Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and umbrellas.",
        "public_id": "01a015d5-a8cb-7309-8ddd-3b51200d4b10",
        "storage_key": "property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
        "width": 1553,
        "height": 874
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Housing Close to Jefferson Stratford Hospital",
      "seo_description": "Discover Holly Court, offering housing close to Jefferson Stratford Hospital in Gloucester County. Modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "page_item_url": "apartments-near-alcyon-lake-pitman-nj-holly-court-355",
      "search_query": "apartments near Alcyon Lake Pitman NJ",
      "category": "Park",
      "h1_title": "Apartments Near Alcyon Lake in Pitman, NJ",
      "h2_subtitle": "Explore Holly Court's apartments near Alcyon Lake in Pitman, NJ. Experience serene living with modern conveniences and nearby nature.",
      "page_copy": "Nestled in the charming town of Pitman, NJ, Holly Court offers beautiful apartments near Alcyon Lake, providing a perfect blend of nature and modern living. Choose from our studio, one-, or two-bedroom floor plans, all featuring desirable amenities such as hardwood floors and air-conditioning, ideal for anyone seeking comfort and style.\n\nResidents can unwind at the nearby Alcyon Lake or take advantage of Holly Court's own amenities, including a pool, fitness center, and dog park. With its proximity to Alcyon Lake and the vibrant environs of Pitman, NJ, Holly Court sets the stage for a serene and convenient lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and umbrellas.",
        "public_id": "01a015d5-a8cb-7309-8ddd-3b51200d4b10",
        "storage_key": "property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
        "width": 1553,
        "height": 874
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Alcyon Lake in Pitman, NJ",
      "seo_description": "Find serenity at Holly Court with apartments near Alcyon Lake, Pitman, NJ. Enjoy modern amenities and natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "page_item_url": "holly-court-apartments-by-ballard-park-9",
      "search_query": "Holly Court apartments by Ballard Park",
      "category": "Park",
      "h1_title": "Holly Court Apartments by Ballard Park",
      "h2_subtitle": "Discover Holly Court Apartments conveniently located by Ballard Park. Enjoy tranquil living with modern amenities in Pitman, NJ.",
      "page_copy": "Holly Court Apartments, located near the picturesque Ballard Park, offer residents a perfect haven of tranquility and convenience in Pitman, NJ. With a range of studio, one-, and two-bedroom options, each apartment is thoughtfully designed with modern amenities like air conditioning and sleek hardwood floors.\n\nJust a short stroll from Ballard Park, residents of Holly Court can enjoy outdoor recreation and a peaceful neighborhood ambiance. On-site amenities such as the swimming pool, fitness center, and a dog park complement the lifestyle, making it an ideal choice for those seeking comfortable living near the calming landscapes of Ballard Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and umbrellas.",
        "public_id": "01a015d5-a8cb-7309-8ddd-3b51200d4b10",
        "storage_key": "property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
        "width": 1553,
        "height": 874
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Holly Court Apartments by Ballard Park",
      "seo_description": "Explore Holly Court Apartments by Ballard Park featuring modern living and amenities in Pitman, NJ.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "page_item_url": "pitman-nj-rentals-near-shertel-park-holly-court-627",
      "search_query": "Pitman NJ rentals near Shertel Park",
      "category": "Park",
      "h1_title": "Pitman NJ Rentals Near Shertel Park",
      "h2_subtitle": "Explore rentals in Pitman, NJ, near Shertel Park. Holly Court offers modern living with fantastic amenities close to nature.",
      "page_copy": "Holly Court is the premier choice for rentals in Pitman, NJ, especially for those desiring proximity to Shertel Park. Our studio, one-, and two-bedroom apartments provide residents with stylish interiors featuring hardwood floors and air conditioning, perfect for comfortable living.\n\nLocated just a short distance from Shertel Park, Holly Court offers residents easy access to outdoor activities and relaxation. Complemented by community amenities like a pool, fitness center, and a delightfully serene sundeck, Holly Court ensures a balanced lifestyle filled with both leisure and nature's tranquility.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and umbrellas.",
        "public_id": "01a015d5-a8cb-7309-8ddd-3b51200d4b10",
        "storage_key": "property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
        "width": 1553,
        "height": 874
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pitman NJ Rentals Near Shertel Park",
      "seo_description": "Discover Holly Court's rentals in Pitman, NJ near Shertel Park. Experience comfort with modern amenities and nearby park access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "page_item_url": "apartments-close-to-betty-park-holly-court-553",
      "search_query": "apartments close to Betty Park 08071",
      "category": "Park",
      "h1_title": "Apartments Close to Betty Park in 08071",
      "h2_subtitle": "Discover Holly Court's beautiful apartments close to Betty Park in the 08071 area. Enjoy convenient living with modern amenities.",
      "page_copy": "Located in the heart of Pitman, NJ, Holly Court offers stunning apartments close to Betty Park in the 08071 zip code. Choose from stylish studio, one-, and two-bedroom layouts, complete with modern features like air conditioning and hardwood floors, crafted for your comfort.\n\nJust a short distance from Betty Park, Holly Court combines the charm of nature with modern living amenities. Residents can enjoy on-site features such as a refreshing pool and fully-equipped fitness center, ensuring both relaxation and an active lifestyle, all in the vicinity of beautiful Betty Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and umbrellas.",
        "public_id": "01a015d5-a8cb-7309-8ddd-3b51200d4b10",
        "storage_key": "property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
        "width": 1553,
        "height": 874
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Betty Park in 08071",
      "seo_description": "Explore Holly Court's apartments close to Betty Park, 08071. Modern living with easy park access and great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166928",
      "source": "custom",
      "page_item_url": "gloucester-county-apartments-near-alcyon-lake-holly-court-835",
      "search_query": "Gloucester County apartments near Alcyon Lake",
      "category": "Park",
      "h1_title": "Gloucester County Apartments Near Alcyon Lake",
      "h2_subtitle": "Find your perfect home in Gloucester County near Alcyon Lake. Holly Court offers modern amenities and comfortable living in Pitman, NJ.",
      "page_copy": "Holly Court in Pitman, NJ, presents exceptional apartment living options in Gloucester County, ideally situated near the tranquil Alcyon Lake. Our community offers a variety of studio, one-, and two-bedroom floor plans, featuring contemporary amenities such as air conditioning and hardwood floors to enhance your living experience.\n\nNestled close to Alcyon Lake, Holly Court provides residents with easy access to peaceful natural surroundings, perfect for outdoor enthusiasts. Enjoy community features like a sparkling pool, fitness center, and expansive sundeck, ensuring that leisure, convenience, and the beauty of Alcyon Lake are right at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and umbrellas.",
        "public_id": "01a015d5-a8cb-7309-8ddd-3b51200d4b10",
        "storage_key": "property/6767906449166928/01a015d5-a8cb-7309-8ddd-3b51200d4b10.webp",
        "width": 1553,
        "height": 874
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gloucester County Apartments Near Alcyon Lake",
      "seo_description": "Discover Holly Court's Gloucester County apartments near Alcyon Lake. Enjoy stylish living with top amenities in Pitman, NJ.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5348"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18067936853"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4973291"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-K8XL77QW"
    },
    {
      "ID": "custom_realpage_id_2",
      "type": "STRING",
      "value": null
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://livehollycourt.fatwin.com/api/websites/resources/1?x=UkpRYUNBeFdoS0tsbGRib05HSGRBbHR4SjBSd1o5R0pPT0pTd1JUanBUeVJuTGxwMUxiMWQ0L2pEQ21pKzRPMmdwbXJvV2s3OUJKeVJhTTUzZFZERXc9PQ2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Belmont"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "40540853429"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_resident_portal_url_2",
      "type": "STRING",
      "value": null
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "954a10c2-43e6-11ef-8611-eb7635df52b5"
    },
    {
      "ID": "custom_eliseai_tour_scheduler",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/954a10c2-43e6-11ef-8611-eb7635df52b5/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bbc32e5-b155-40a7-886b-b483419a5646"
    },
    {
      "ID": "custom_eliseai_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/954a10c2-43e6-11ef-8611-eb7635df52b5/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InR2MnRZT0NVWWNyTlI2eFVBVU9xSWc9PSIsInZhbHVlIjoiczVXaUZBYWNkZmRkL0QzL3pUUjJ6Zz09IiwibWFjIjoiYjU0OWY3Zjg1ZDYxYWU0NTJlZDllNjI3M2YxZmFjMjIyYWMwNzA3NDk3ODBkMjk1OTZhNWFkZTI4NjI0NWJlNiJ9"
    },
    {
      "ID": "custom_loft_resident_download_apple",
      "type": "STRING",
      "value": "https://apps.apple.com/us/app/loft-living/id333244247"
    },
    {
      "ID": "custom_loft_resident_download_google",
      "type": "STRING",
      "value": "https://play.google.com/store/apps/details?id=com.activebuilding.residents"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "5348",
  "custom_repli_id": "18067936853",
  "custom_realpage_id": "4973291",
  "custom_google_gtm_id": "GTM-K8XL77QW",
  "custom_perq_script_url": "https://livehollycourt.fatwin.com/api/websites/resources/1?x=UkpRYUNBeFdoS0tsbGRib05HSGRBbHR4SjBSd1o5R0pPT0pTd1JUanBUeVJuTGxwMUxiMWQ0L2pEQ21pKzRPMmdwbXJvV2s3OUJKeVJhTTUzZFZERXc9PQ2",
  "custom_vibesites_theme": "Belmont",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "40540853429",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "954a10c2-43e6-11ef-8611-eb7635df52b5",
  "custom_eliseai_tour_scheduler": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/954a10c2-43e6-11ef-8611-eb7635df52b5/tour?hideScrollBars=true",
  "custom_eliseai_organization_id": "4bbc32e5-b155-40a7-886b-b483419a5646",
  "custom_eliseai_tour_button_popup": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/954a10c2-43e6-11ef-8611-eb7635df52b5/tour?hideScrollBars=true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InR2MnRZT0NVWWNyTlI2eFVBVU9xSWc9PSIsInZhbHVlIjoiczVXaUZBYWNkZmRkL0QzL3pUUjJ6Zz09IiwibWFjIjoiYjU0OWY3Zjg1ZDYxYWU0NTJlZDllNjI3M2YxZmFjMjIyYWMwNzA3NDk3ODBkMjk1OTZhNWFkZTI4NjI0NWJlNiJ9",
  "custom_loft_resident_download_apple": "https://apps.apple.com/us/app/loft-living/id333244247",
  "custom_loft_resident_download_google": "https://play.google.com/store/apps/details?id=com.activebuilding.residents",
  "custom_audioeye_site_id": "a27a3016-d759-4618-9ee4-823c55b8e810",
  "custom_audioeye_site_hash": "1d2669285012ddd66fb9c51ceba3afc8"
};

export const generatedAt = '2026-10-23T20:39:48.528Z';
